var De = (n, e, t) => {
  if (!e.has(n))
    throw TypeError("Cannot " + t);
};
var E = (n, e, t) => (De(n, e, "read from private field"), t ? t.call(n) : e.get(n)), X = (n, e, t) => {
  if (e.has(n))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(n) : e.set(n, t);
}, F = (n, e, t, s) => (De(n, e, "write to private field"), s ? s.call(n, t) : e.set(n, t), t);
class Xe {
  constructor() {
    this.name = "FormManager", this.forms = [];
  }
  initForms(e = document.querySelector("html")) {
    this.clearForms();
    let t = e.querySelectorAll("[me\\:form]"), s = [];
    for (let r = 0; r < t.length; r++) {
      let i = t[r], a = i.getAttribute("me:form"), u = {
        el: i,
        name: a,
        params: {}
      };
      if (typeof Me.forms[a] != "function") {
        console.warn("You need to have form that exist.", a);
        continue;
      }
      if (i.hasAttribute("me:form:render"))
        continue;
      i.setAttribute("me:form:render", "true");
      let o = i.getAttribute("me:form:data");
      u.params = o ? JSON.parse(o) : {};
      let l = new Me.forms[a](u);
      this.forms.push(l), s.push(l);
    }
    for (const r in s)
      s[r].initialize();
  }
  clearForms() {
    let e = [];
    for (let t in this.forms) {
      let s = this.forms[t];
      typeof s == "object" && (document.body.contains(s.el) ? e.push(s) : s.terminate());
    }
    this.forms = e;
  }
  get name() {
    return this._name;
  }
  set name(e) {
    this._name = e;
  }
}
window.Me || (window.Me = {});
Me.formManager = new Xe();
Me.forms = [];
document.addEventListener("DOMContentLoaded", (n) => {
  Me.formManager.initForms();
});
function P(n) {
  this._maxSize = n, this.clear();
}
P.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
P.prototype.get = function(n) {
  return this._values[n];
};
P.prototype.set = function(n, e) {
  return this._size >= this._maxSize && this.clear(), n in this._values || this._size++, this._values[n] = e;
};
var Je = /[^.^\]^[]+|(?=\[\]|\.\.)/g, Re = /^\d+$/, We = /^\d/, Qe = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, et = /^\s*(['"]?)(.*?)(\1)\s*$/, _e = 512, Oe = new P(_e), Be = new P(_e), Ie = new P(_e), V = {
  Cache: P,
  split: pe,
  normalizePath: ce,
  setter: function(n) {
    var e = ce(n);
    return Be.get(n) || Be.set(n, function(s, r) {
      for (var i = 0, a = e.length, u = s; i < a - 1; ) {
        var o = e[i];
        if (o === "__proto__" || o === "constructor" || o === "prototype")
          return s;
        u = u[e[i++]];
      }
      u[e[i]] = r;
    });
  },
  getter: function(n, e) {
    var t = ce(n);
    return Ie.get(n) || Ie.set(n, function(r) {
      for (var i = 0, a = t.length; i < a; )
        if (r != null || !e)
          r = r[t[i++]];
        else
          return;
      return r;
    });
  },
  join: function(n) {
    return n.reduce(function(e, t) {
      return e + (Ee(t) || Re.test(t) ? "[" + t + "]" : (e ? "." : "") + t);
    }, "");
  },
  forEach: function(n, e, t) {
    tt(Array.isArray(n) ? n : pe(n), e, t);
  }
};
function ce(n) {
  return Oe.get(n) || Oe.set(
    n,
    pe(n).map(function(e) {
      return e.replace(et, "$2");
    })
  );
}
function pe(n) {
  return n.match(Je) || [""];
}
function tt(n, e, t) {
  var s = n.length, r, i, a, u;
  for (i = 0; i < s; i++)
    r = n[i], r && (nt(r) && (r = '"' + r + '"'), u = Ee(r), a = !u && /^\d+$/.test(r), e.call(t, r, u, a, i, n));
}
function Ee(n) {
  return typeof n == "string" && n && ["'", '"'].indexOf(n.charAt(0)) !== -1;
}
function st(n) {
  return n.match(We) && !n.match(Re);
}
function rt(n) {
  return Qe.test(n);
}
function nt(n) {
  return !Ee(n) && (st(n) || rt(n));
}
const it = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, ne = (n) => n.match(it) || [], ie = (n) => n[0].toUpperCase() + n.slice(1), be = (n, e) => ne(n).join(e).toLowerCase(), je = (n) => ne(n).reduce(
  (e, t) => `${e}${e ? t[0].toUpperCase() + t.slice(1).toLowerCase() : t.toLowerCase()}`,
  ""
), at = (n) => ie(je(n)), ut = (n) => be(n, "_"), ot = (n) => be(n, "-"), lt = (n) => ie(be(n, " ")), ht = (n) => ne(n).map(ie).join(" ");
var de = {
  words: ne,
  upperFirst: ie,
  camelCase: je,
  pascalCase: at,
  snakeCase: ut,
  kebabCase: ot,
  sentenceCase: lt,
  titleCase: ht
}, xe = { exports: {} };
xe.exports = function(n) {
  return Le(ct(n), n);
};
xe.exports.array = Le;
function Le(n, e) {
  var t = n.length, s = new Array(t), r = {}, i = t, a = dt(e), u = ft(n);
  for (e.forEach(function(l) {
    if (!u.has(l[0]) || !u.has(l[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); i--; )
    r[i] || o(n[i], i, /* @__PURE__ */ new Set());
  return s;
  function o(l, c, d) {
    if (d.has(l)) {
      var p;
      try {
        p = ", node was:" + JSON.stringify(l);
      } catch {
        p = "";
      }
      throw new Error("Cyclic dependency" + p);
    }
    if (!u.has(l))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(l));
    if (!r[c]) {
      r[c] = !0;
      var v = a.get(l) || /* @__PURE__ */ new Set();
      if (v = Array.from(v), c = v.length) {
        d.add(l);
        do {
          var _ = v[--c];
          o(_, u.get(_), d);
        } while (c);
        d.delete(l);
      }
      s[--t] = l;
    }
  }
}
function ct(n) {
  for (var e = /* @__PURE__ */ new Set(), t = 0, s = n.length; t < s; t++) {
    var r = n[t];
    e.add(r[0]), e.add(r[1]);
  }
  return Array.from(e);
}
function dt(n) {
  for (var e = /* @__PURE__ */ new Map(), t = 0, s = n.length; t < s; t++) {
    var r = n[t];
    e.has(r[0]) || e.set(r[0], /* @__PURE__ */ new Set()), e.has(r[1]) || e.set(r[1], /* @__PURE__ */ new Set()), e.get(r[0]).add(r[1]);
  }
  return e;
}
function ft(n) {
  for (var e = /* @__PURE__ */ new Map(), t = 0, s = n.length; t < s; t++)
    e.set(n[t], t);
  return e;
}
const pt = Object.prototype.toString, mt = Error.prototype.toString, gt = RegExp.prototype.toString, kt = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", vt = /^Symbol\((.*)\)(.*)$/;
function _t(n) {
  return n != +n ? "NaN" : n === 0 && 1 / n < 0 ? "-0" : "" + n;
}
function Ve(n, e = !1) {
  if (n == null || n === !0 || n === !1)
    return "" + n;
  const t = typeof n;
  if (t === "number")
    return _t(n);
  if (t === "string")
    return e ? `"${n}"` : n;
  if (t === "function")
    return "[Function " + (n.name || "anonymous") + "]";
  if (t === "symbol")
    return kt.call(n).replace(vt, "Symbol($1)");
  const s = pt.call(n).slice(8, -1);
  return s === "Date" ? isNaN(n.getTime()) ? "" + n : n.toISOString(n) : s === "Error" || n instanceof Error ? "[" + mt.call(n) + "]" : s === "RegExp" ? gt.call(n) : null;
}
function U(n, e) {
  let t = Ve(n, e);
  return t !== null ? t : JSON.stringify(n, function(s, r) {
    let i = Ve(this[s], e);
    return i !== null ? i : r;
  }, 2);
}
function Ne(n) {
  return n == null ? [] : [].concat(n);
}
let Et = /\$\{\s*(\w+)\s*\}/g;
class A extends Error {
  static formatError(e, t) {
    const s = t.label || t.path || "this";
    return s !== t.path && (t = Object.assign({}, t, {
      path: s
    })), typeof e == "string" ? e.replace(Et, (r, i) => U(t[i])) : typeof e == "function" ? e(t) : e;
  }
  static isError(e) {
    return e && e.name === "ValidationError";
  }
  constructor(e, t, s, r) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = t, this.path = s, this.type = r, this.errors = [], this.inner = [], Ne(e).forEach((i) => {
      A.isError(i) ? (this.errors.push(...i.errors), this.inner = this.inner.concat(i.inner.length ? i.inner : i)) : this.errors.push(i);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, A);
  }
}
let D = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: n,
    type: e,
    value: t,
    originalValue: s
  }) => {
    const r = s != null && s !== t ? ` (cast from the value \`${U(s, !0)}\`).` : ".";
    return e !== "mixed" ? `${n} must be a \`${e}\` type, but the final value was: \`${U(t, !0)}\`` + r : `${n} must match the configured type. The validated value was: \`${U(t, !0)}\`` + r;
  }
}, bt = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, xt = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, me = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, At = {
  isValue: "${path} field must be ${value}"
}, ge = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, yt = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: D,
  string: bt,
  number: xt,
  date: me,
  object: ge,
  array: yt,
  boolean: At
});
const Ae = (n) => n && n.__isYupSchema__;
class te {
  static fromOptions(e, t) {
    if (!t.then && !t.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: s,
      then: r,
      otherwise: i
    } = t, a = typeof s == "function" ? s : (...u) => u.every((o) => o === s);
    return new te(e, (u, o) => {
      var l;
      let c = a(...u) ? r : i;
      return (l = c == null ? void 0 : c(o)) != null ? l : o;
    });
  }
  constructor(e, t) {
    this.fn = void 0, this.refs = e, this.refs = e, this.fn = t;
  }
  resolve(e, t) {
    let s = this.refs.map((i) => i.getValue(t == null ? void 0 : t.value, t == null ? void 0 : t.parent, t == null ? void 0 : t.context)), r = this.fn(s, e, t);
    if (r === void 0 || r === e)
      return e;
    if (!Ae(r))
      throw new TypeError("conditions must return a schema object");
    return r.resolve(t);
  }
}
const W = {
  context: "$",
  value: "."
};
class R {
  constructor(e, t = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof e != "string")
      throw new TypeError("ref must be a string, got: " + e);
    if (this.key = e.trim(), e === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === W.context, this.isValue = this.key[0] === W.value, this.isSibling = !this.isContext && !this.isValue;
    let s = this.isContext ? W.context : this.isValue ? W.value : "";
    this.path = this.key.slice(s.length), this.getter = this.path && V.getter(this.path, !0), this.map = t.map;
  }
  getValue(e, t, s) {
    let r = this.isContext ? s : this.isValue ? e : t;
    return this.getter && (r = this.getter(r || {})), this.map && (r = this.map(r)), r;
  }
  cast(e, t) {
    return this.getValue(e, t == null ? void 0 : t.parent, t == null ? void 0 : t.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(e) {
    return e && e.__isYupRef;
  }
}
R.prototype.__isYupRef = !0;
const ke = (n) => n == null;
function L(n) {
  function e({
    value: t,
    path: s = "",
    options: r,
    originalValue: i,
    schema: a
  }, u, o) {
    const {
      name: l,
      test: c,
      params: d,
      message: p,
      skipAbsent: v
    } = n;
    let {
      parent: _,
      context: k,
      abortEarly: C = a.spec.abortEarly
    } = r;
    function Y(g) {
      return R.isRef(g) ? g.getValue(t, _, k) : g;
    }
    function Z(g = {}) {
      const j = Object.assign({
        value: t,
        originalValue: i,
        label: a.spec.label,
        path: g.path || s,
        spec: a.spec
      }, d, g.params);
      for (const Te of Object.keys(j))
        j[Te] = Y(j[Te]);
      const we = new A(A.formatError(g.message || p, j), t, j.path, g.type || l);
      return we.params = j, we;
    }
    const oe = C ? u : o;
    let K = {
      path: s,
      parent: _,
      type: l,
      from: r.from,
      createError: Z,
      resolve: Y,
      options: r,
      originalValue: i,
      schema: a
    };
    const Fe = (g) => {
      A.isError(g) ? oe(g) : g ? o(null) : oe(Z());
    }, le = (g) => {
      A.isError(g) ? oe(g) : u(g);
    }, Se = v && ke(t);
    if (!r.sync) {
      try {
        Promise.resolve(Se ? !0 : c.call(K, t, K)).then(Fe, le);
      } catch (g) {
        le(g);
      }
      return;
    }
    let he;
    try {
      var Ce;
      if (he = Se ? !0 : c.call(K, t, K), typeof ((Ce = he) == null ? void 0 : Ce.then) == "function")
        throw new Error(`Validation test of type: "${K.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch (g) {
      le(g);
      return;
    }
    Fe(he);
  }
  return e.OPTIONS = n, e;
}
function Ft(n, e, t, s = t) {
  let r, i, a;
  return e ? (V.forEach(e, (u, o, l) => {
    let c = o ? u.slice(1, u.length - 1) : u;
    n = n.resolve({
      context: s,
      parent: r,
      value: t
    });
    let d = n.type === "tuple", p = l ? parseInt(c, 10) : 0;
    if (n.innerType || d) {
      if (d && !l)
        throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${a}" must contain an index to the tuple element, e.g. "${a}[0]"`);
      if (t && p >= t.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${u}, in the path: ${e}. because there is no value at that index. `);
      r = t, t = t && t[p], n = d ? n.spec.types[p] : n.innerType;
    }
    if (!l) {
      if (!n.fields || !n.fields[c])
        throw new Error(`The schema does not contain the path: ${e}. (failed at: ${a} which is a type: "${n.type}")`);
      r = t, t = t && t[c], n = n.fields[c];
    }
    i = c, a = o ? "[" + u + "]" : "." + u;
  }), {
    schema: n,
    parent: r,
    parentPath: i
  }) : {
    parent: r,
    parentPath: e,
    schema: n
  };
}
class se extends Set {
  describe() {
    const e = [];
    for (const t of this.values())
      e.push(R.isRef(t) ? t.describe() : t);
    return e;
  }
  resolveAll(e) {
    let t = [];
    for (const s of this.values())
      t.push(e(s));
    return t;
  }
  clone() {
    return new se(this.values());
  }
  merge(e, t) {
    const s = this.clone();
    return e.forEach((r) => s.add(r)), t.forEach((r) => s.delete(r)), s;
  }
}
function N(n, e = /* @__PURE__ */ new Map()) {
  if (Ae(n) || !n || typeof n != "object")
    return n;
  if (e.has(n))
    return e.get(n);
  let t;
  if (n instanceof Date)
    t = new Date(n.getTime()), e.set(n, t);
  else if (n instanceof RegExp)
    t = new RegExp(n), e.set(n, t);
  else if (Array.isArray(n)) {
    t = new Array(n.length), e.set(n, t);
    for (let s = 0; s < n.length; s++)
      t[s] = N(n[s], e);
  } else if (n instanceof Map) {
    t = /* @__PURE__ */ new Map(), e.set(n, t);
    for (const [s, r] of n.entries())
      t.set(s, N(r, e));
  } else if (n instanceof Set) {
    t = /* @__PURE__ */ new Set(), e.set(n, t);
    for (const s of n)
      t.add(N(s, e));
  } else if (n instanceof Object) {
    t = {}, e.set(n, t);
    for (const [s, r] of Object.entries(n))
      t[s] = N(r, e);
  } else
    throw Error(`Unable to clone ${n}`);
  return t;
}
class T {
  constructor(e) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new se(), this._blacklist = new se(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(D.notType);
    }), this.type = e.type, this._typeCheck = e.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, e == null ? void 0 : e.spec), this.withMutation((t) => {
      t.nonNullable();
    });
  }
  get _type() {
    return this.type;
  }
  clone(e) {
    if (this._mutate)
      return e && Object.assign(this.spec, e), this;
    const t = Object.create(Object.getPrototypeOf(this));
    return t.type = this.type, t._typeCheck = this._typeCheck, t._whitelist = this._whitelist.clone(), t._blacklist = this._blacklist.clone(), t.internalTests = Object.assign({}, this.internalTests), t.exclusiveTests = Object.assign({}, this.exclusiveTests), t.deps = [...this.deps], t.conditions = [...this.conditions], t.tests = [...this.tests], t.transforms = [...this.transforms], t.spec = N(Object.assign({}, this.spec, e)), t;
  }
  label(e) {
    let t = this.clone();
    return t.spec.label = e, t;
  }
  meta(...e) {
    if (e.length === 0)
      return this.spec.meta;
    let t = this.clone();
    return t.spec.meta = Object.assign(t.spec.meta || {}, e[0]), t;
  }
  withMutation(e) {
    let t = this._mutate;
    this._mutate = !0;
    let s = e(this);
    return this._mutate = t, s;
  }
  concat(e) {
    if (!e || e === this)
      return this;
    if (e.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${e.type}`);
    let t = this, s = e.clone();
    const r = Object.assign({}, t.spec, s.spec);
    return s.spec = r, s.internalTests = Object.assign({}, t.internalTests, s.internalTests), s._whitelist = t._whitelist.merge(e._whitelist, e._blacklist), s._blacklist = t._blacklist.merge(e._blacklist, e._whitelist), s.tests = t.tests, s.exclusiveTests = t.exclusiveTests, s.withMutation((i) => {
      e.tests.forEach((a) => {
        i.test(a.OPTIONS);
      });
    }), s.transforms = [...t.transforms, ...s.transforms], s;
  }
  isType(e) {
    return e == null ? !!(this.spec.nullable && e === null || this.spec.optional && e === void 0) : this._typeCheck(e);
  }
  resolve(e) {
    let t = this;
    if (t.conditions.length) {
      let s = t.conditions;
      t = t.clone(), t.conditions = [], t = s.reduce((r, i) => i.resolve(r, e), t), t = t.resolve(e);
    }
    return t;
  }
  resolveOptions(e) {
    var t, s, r;
    return Object.assign({}, e, {
      from: e.from || [],
      strict: (t = e.strict) != null ? t : this.spec.strict,
      abortEarly: (s = e.abortEarly) != null ? s : this.spec.abortEarly,
      recursive: (r = e.recursive) != null ? r : this.spec.recursive
    });
  }
  cast(e, t = {}) {
    let s = this.resolve(Object.assign({
      value: e
    }, t)), r = t.assert === "ignore-optionality", i = s._cast(e, t);
    if (t.assert !== !1 && !s.isType(i)) {
      if (r && ke(i))
        return i;
      let a = U(e), u = U(i);
      throw new TypeError(`The value of ${t.path || "field"} could not be cast to a value that satisfies the schema type: "${s.type}". 

attempted value: ${a} 
` + (u !== a ? `result of cast: ${u}` : ""));
    }
    return i;
  }
  _cast(e, t) {
    let s = e === void 0 ? e : this.transforms.reduce((r, i) => i.call(this, r, e, this), e);
    return s === void 0 && (s = this.getDefault()), s;
  }
  _validate(e, t = {}, s, r) {
    let {
      path: i,
      originalValue: a = e,
      strict: u = this.spec.strict
    } = t, o = e;
    u || (o = this._cast(o, Object.assign({
      assert: !1
    }, t)));
    let l = [];
    for (let c of Object.values(this.internalTests))
      c && l.push(c);
    this.runTests({
      path: i,
      value: o,
      originalValue: a,
      options: t,
      tests: l
    }, s, (c) => {
      if (c.length)
        return r(c, o);
      this.runTests({
        path: i,
        value: o,
        originalValue: a,
        options: t,
        tests: this.tests
      }, s, r);
    });
  }
  runTests(e, t, s) {
    let r = !1, {
      tests: i,
      value: a,
      originalValue: u,
      path: o,
      options: l
    } = e, c = (k) => {
      r || (r = !0, t(k, a));
    }, d = (k) => {
      r || (r = !0, s(k, a));
    }, p = i.length, v = [];
    if (!p)
      return d([]);
    let _ = {
      value: a,
      originalValue: u,
      path: o,
      options: l,
      schema: this
    };
    for (let k = 0; k < i.length; k++) {
      const C = i[k];
      C(_, c, function(Z) {
        Z && (v = v.concat(Z)), --p <= 0 && d(v);
      });
    }
  }
  asNestedTest({
    key: e,
    index: t,
    parent: s,
    parentPath: r,
    originalParent: i,
    options: a
  }) {
    const u = e != null ? e : t;
    if (u == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const o = typeof u == "number";
    let l = s[u];
    const c = Object.assign({}, a, {
      strict: !0,
      parent: s,
      value: l,
      originalValue: i[u],
      key: void 0,
      [o ? "index" : "key"]: u,
      path: o || u.includes(".") ? `${r || ""}[${l ? u : `"${u}"`}]` : (r ? `${r}.` : "") + e
    });
    return (d, p, v) => this.resolve(c)._validate(l, c, p, v);
  }
  validate(e, t) {
    let s = this.resolve(Object.assign({}, t, {
      value: e
    }));
    return new Promise((r, i) => s._validate(e, t, (a, u) => {
      A.isError(a) && (a.value = u), i(a);
    }, (a, u) => {
      a.length ? i(new A(a, u)) : r(u);
    }));
  }
  validateSync(e, t) {
    let s = this.resolve(Object.assign({}, t, {
      value: e
    })), r;
    return s._validate(e, Object.assign({}, t, {
      sync: !0
    }), (i, a) => {
      throw A.isError(i) && (i.value = a), i;
    }, (i, a) => {
      if (i.length)
        throw new A(i, e);
      r = a;
    }), r;
  }
  isValid(e, t) {
    return this.validate(e, t).then(() => !0, (s) => {
      if (A.isError(s))
        return !1;
      throw s;
    });
  }
  isValidSync(e, t) {
    try {
      return this.validateSync(e, t), !0;
    } catch (s) {
      if (A.isError(s))
        return !1;
      throw s;
    }
  }
  _getDefault() {
    let e = this.spec.default;
    return e == null ? e : typeof e == "function" ? e.call(this) : N(e);
  }
  getDefault(e) {
    return this.resolve(e || {})._getDefault();
  }
  default(e) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: e
    });
  }
  strict(e = !0) {
    return this.clone({
      strict: e
    });
  }
  nullability(e, t) {
    const s = this.clone({
      nullable: e
    });
    return s.internalTests.nullable = L({
      message: t,
      name: "nullable",
      test(r) {
        return r === null ? this.schema.spec.nullable : !0;
      }
    }), s;
  }
  optionality(e, t) {
    const s = this.clone({
      optional: e
    });
    return s.internalTests.optionality = L({
      message: t,
      name: "optionality",
      test(r) {
        return r === void 0 ? this.schema.spec.optional : !0;
      }
    }), s;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(e = D.defined) {
    return this.optionality(!1, e);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(e = D.notNull) {
    return this.nullability(!1, e);
  }
  required(e = D.required) {
    return this.clone().withMutation((t) => t.nonNullable(e).defined(e));
  }
  notRequired() {
    return this.clone().withMutation((e) => e.nullable().optional());
  }
  transform(e) {
    let t = this.clone();
    return t.transforms.push(e), t;
  }
  test(...e) {
    let t;
    if (e.length === 1 ? typeof e[0] == "function" ? t = {
      test: e[0]
    } : t = e[0] : e.length === 2 ? t = {
      name: e[0],
      test: e[1]
    } : t = {
      name: e[0],
      message: e[1],
      test: e[2]
    }, t.message === void 0 && (t.message = D.default), typeof t.test != "function")
      throw new TypeError("`test` is a required parameters");
    let s = this.clone(), r = L(t), i = t.exclusive || t.name && s.exclusiveTests[t.name] === !0;
    if (t.exclusive && !t.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return t.name && (s.exclusiveTests[t.name] = !!t.exclusive), s.tests = s.tests.filter((a) => !(a.OPTIONS.name === t.name && (i || a.OPTIONS.test === r.OPTIONS.test))), s.tests.push(r), s;
  }
  when(e, t) {
    !Array.isArray(e) && typeof e != "string" && (t = e, e = ".");
    let s = this.clone(), r = Ne(e).map((i) => new R(i));
    return r.forEach((i) => {
      i.isSibling && s.deps.push(i.key);
    }), s.conditions.push(typeof t == "function" ? new te(r, t) : te.fromOptions(r, t)), s;
  }
  typeError(e) {
    let t = this.clone();
    return t.internalTests.typeError = L({
      message: e,
      name: "typeError",
      test(s) {
        return !ke(s) && !this.schema._typeCheck(s) ? this.createError({
          params: {
            type: this.schema.type
          }
        }) : !0;
      }
    }), t;
  }
  oneOf(e, t = D.oneOf) {
    let s = this.clone();
    return e.forEach((r) => {
      s._whitelist.add(r), s._blacklist.delete(r);
    }), s.internalTests.whiteList = L({
      message: t,
      name: "oneOf",
      skipAbsent: !0,
      test(r) {
        let i = this.schema._whitelist, a = i.resolveAll(this.resolve);
        return a.includes(r) ? !0 : this.createError({
          params: {
            values: Array.from(i).join(", "),
            resolved: a
          }
        });
      }
    }), s;
  }
  notOneOf(e, t = D.notOneOf) {
    let s = this.clone();
    return e.forEach((r) => {
      s._blacklist.add(r), s._whitelist.delete(r);
    }), s.internalTests.blacklist = L({
      message: t,
      name: "notOneOf",
      test(r) {
        let i = this.schema._blacklist, a = i.resolveAll(this.resolve);
        return a.includes(r) ? this.createError({
          params: {
            values: Array.from(i).join(", "),
            resolved: a
          }
        }) : !0;
      }
    }), s;
  }
  strip(e = !0) {
    let t = this.clone();
    return t.spec.strip = e, t;
  }
  describe(e) {
    const t = (e ? this.resolve(e) : this).clone(), {
      label: s,
      meta: r,
      optional: i,
      nullable: a
    } = t.spec;
    return {
      meta: r,
      label: s,
      optional: i,
      nullable: a,
      default: t.getDefault(e),
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((o) => ({
        name: o.OPTIONS.name,
        params: o.OPTIONS.params
      })).filter((o, l, c) => c.findIndex((d) => d.name === o.name) === l)
    };
  }
}
T.prototype.__isYupSchema__ = !0;
for (const n of ["validate", "validateSync"])
  T.prototype[`${n}At`] = function(e, t, s = {}) {
    const {
      parent: r,
      parentPath: i,
      schema: a
    } = Ft(this, e, t, s.context);
    return a[n](r && r[i], Object.assign({}, s, {
      parent: r,
      path: e
    }));
  };
for (const n of ["equals", "is"])
  T.prototype[n] = T.prototype.oneOf;
for (const n of ["not", "nope"])
  T.prototype[n] = T.prototype.notOneOf;
var St = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function Ct(n) {
  var e = [1, 4, 5, 6, 7, 10, 11], t = 0, s, r;
  if (r = St.exec(n)) {
    for (var i = 0, a; a = e[i]; ++i)
      r[a] = +r[a] || 0;
    r[2] = (+r[2] || 1) - 1, r[3] = +r[3] || 1, r[7] = r[7] ? String(r[7]).substr(0, 3) : 0, (r[8] === void 0 || r[8] === "") && (r[9] === void 0 || r[9] === "") ? s = +new Date(r[1], r[2], r[3], r[4], r[5], r[6], r[7]) : (r[8] !== "Z" && r[9] !== void 0 && (t = r[10] * 60 + r[11], r[9] === "+" && (t = 0 - t)), s = Date.UTC(r[1], r[2], r[3], r[4], r[5] + t, r[6], r[7]));
  } else
    s = Date.parse ? Date.parse(n) : NaN;
  return s;
}
let wt = new Date(""), Tt = (n) => Object.prototype.toString.call(n) === "[object Date]";
class ae extends T {
  constructor() {
    super({
      type: "date",
      check(e) {
        return Tt(e) && !isNaN(e.getTime());
      }
    }), this.withMutation(() => {
      this.transform((e, t, s) => !s.spec.coerce || s.isType(e) ? e : (e = Ct(e), isNaN(e) ? ae.INVALID_DATE : new Date(e)));
    });
  }
  prepareParam(e, t) {
    let s;
    if (R.isRef(e))
      s = e;
    else {
      let r = this.cast(e);
      if (!this._typeCheck(r))
        throw new TypeError(`\`${t}\` must be a Date or a value that can be \`cast()\` to a Date`);
      s = r;
    }
    return s;
  }
  min(e, t = me.min) {
    let s = this.prepareParam(e, "min");
    return this.test({
      message: t,
      name: "min",
      exclusive: !0,
      params: {
        min: e
      },
      skipAbsent: !0,
      test(r) {
        return r >= this.resolve(s);
      }
    });
  }
  max(e, t = me.max) {
    let s = this.prepareParam(e, "max");
    return this.test({
      message: t,
      name: "max",
      exclusive: !0,
      params: {
        max: e
      },
      skipAbsent: !0,
      test(r) {
        return r <= this.resolve(s);
      }
    });
  }
}
ae.INVALID_DATE = wt;
ae.prototype;
function Dt(n, e = []) {
  let t = [], s = /* @__PURE__ */ new Set(), r = new Set(e.map(([a, u]) => `${a}-${u}`));
  function i(a, u) {
    let o = V.split(a)[0];
    s.add(o), r.has(`${u}-${o}`) || t.push([u, o]);
  }
  for (const a of Object.keys(n)) {
    let u = n[a];
    s.add(a), R.isRef(u) && u.isSibling ? i(u.path, a) : Ae(u) && "deps" in u && u.deps.forEach((o) => i(o, a));
  }
  return xe.exports.array(Array.from(s), t).reverse();
}
function $e(n, e) {
  let t = 1 / 0;
  return n.some((s, r) => {
    var i;
    if ((i = e.path) != null && i.includes(s))
      return t = r, !0;
  }), t;
}
function Ue(n) {
  return (e, t) => $e(n, e) - $e(n, t);
}
const Ot = (n, e, t) => {
  if (typeof n != "string")
    return n;
  let s = n;
  try {
    s = JSON.parse(n);
  } catch {
  }
  return t.isType(s) ? s : n;
};
function Q(n) {
  if ("fields" in n) {
    const e = {};
    for (const [t, s] of Object.entries(n.fields))
      e[t] = Q(s);
    return n.setFields(e);
  }
  if (n.type === "array") {
    const e = n.optional();
    return e.innerType && (e.innerType = Q(e.innerType)), e;
  }
  return n.type === "tuple" ? n.optional().clone({
    types: n.spec.types.map(Q)
  }) : "optional" in n ? n.optional() : n;
}
const Bt = (n, e) => {
  const t = [...V.normalizePath(e)];
  if (t.length === 1)
    return t[0] in n;
  let s = t.pop(), r = V.getter(V.join(t), !0)(n);
  return !!(r && s in r);
};
let Pe = (n) => Object.prototype.toString.call(n) === "[object Object]";
function It(n, e) {
  let t = Object.keys(n.fields);
  return Object.keys(e).filter((s) => t.indexOf(s) === -1);
}
const Mt = Ue([]);
function qe(n) {
  return new He(n);
}
class He extends T {
  constructor(e) {
    super({
      type: "object",
      check(t) {
        return Pe(t) || typeof t == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = Mt, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      e && this.shape(e);
    });
  }
  _cast(e, t = {}) {
    var s;
    let r = super._cast(e, t);
    if (r === void 0)
      return this.getDefault();
    if (!this._typeCheck(r))
      return r;
    let i = this.fields, a = (s = t.stripUnknown) != null ? s : this.spec.noUnknown, u = [].concat(this._nodes, Object.keys(r).filter((d) => !this._nodes.includes(d))), o = {}, l = Object.assign({}, t, {
      parent: o,
      __validating: t.__validating || !1
    }), c = !1;
    for (const d of u) {
      let p = i[d], v = d in r;
      if (p) {
        let _, k = r[d];
        l.path = (t.path ? `${t.path}.` : "") + d, p = p.resolve({
          value: k,
          context: t.context,
          parent: o
        });
        let C = p instanceof T ? p.spec : void 0, Y = C == null ? void 0 : C.strict;
        if (C != null && C.strip) {
          c = c || d in r;
          continue;
        }
        _ = !t.__validating || !Y ? p.cast(r[d], l) : r[d], _ !== void 0 && (o[d] = _);
      } else
        v && !a && (o[d] = r[d]);
      (v !== d in o || o[d] !== r[d]) && (c = !0);
    }
    return c ? o : r;
  }
  _validate(e, t = {}, s, r) {
    let {
      from: i = [],
      originalValue: a = e,
      recursive: u = this.spec.recursive
    } = t;
    t.from = [{
      schema: this,
      value: a
    }, ...i], t.__validating = !0, t.originalValue = a, super._validate(e, t, s, (o, l) => {
      if (!u || !Pe(l)) {
        r(o, l);
        return;
      }
      a = a || l;
      let c = [];
      for (let d of this._nodes) {
        let p = this.fields[d];
        !p || R.isRef(p) || c.push(p.asNestedTest({
          options: t,
          key: d,
          parent: l,
          parentPath: t.path,
          originalParent: a
        }));
      }
      this.runTests({
        tests: c,
        value: l,
        originalValue: a,
        options: t
      }, s, (d) => {
        r(d.sort(this._sortErrors).concat(o), l);
      });
    });
  }
  clone(e) {
    const t = super.clone(e);
    return t.fields = Object.assign({}, this.fields), t._nodes = this._nodes, t._excludedEdges = this._excludedEdges, t._sortErrors = this._sortErrors, t;
  }
  concat(e) {
    let t = super.concat(e), s = t.fields;
    for (let [r, i] of Object.entries(this.fields)) {
      const a = s[r];
      s[r] = a === void 0 ? i : a;
    }
    return t.withMutation((r) => r.setFields(s, this._excludedEdges));
  }
  _getDefault() {
    if ("default" in this.spec)
      return super._getDefault();
    if (!this._nodes.length)
      return;
    let e = {};
    return this._nodes.forEach((t) => {
      const s = this.fields[t];
      e[t] = s && "getDefault" in s ? s.getDefault() : void 0;
    }), e;
  }
  setFields(e, t) {
    let s = this.clone();
    return s.fields = e, s._nodes = Dt(e, t), s._sortErrors = Ue(Object.keys(e)), t && (s._excludedEdges = t), s;
  }
  shape(e, t = []) {
    return this.clone().withMutation((s) => {
      let r = s._excludedEdges;
      return t.length && (Array.isArray(t[0]) || (t = [t]), r = [...s._excludedEdges, ...t]), s.setFields(Object.assign(s.fields, e), r);
    });
  }
  partial() {
    const e = {};
    for (const [t, s] of Object.entries(this.fields))
      e[t] = "optional" in s && s.optional instanceof Function ? s.optional() : s;
    return this.setFields(e);
  }
  deepPartial() {
    return Q(this);
  }
  pick(e) {
    const t = {};
    for (const s of e)
      this.fields[s] && (t[s] = this.fields[s]);
    return this.setFields(t);
  }
  omit(e) {
    const t = Object.assign({}, this.fields);
    for (const s of e)
      delete t[s];
    return this.setFields(t);
  }
  from(e, t, s) {
    let r = V.getter(e, !0);
    return this.transform((i) => {
      if (!i)
        return i;
      let a = i;
      return Bt(i, e) && (a = Object.assign({}, i), s || delete a[e], a[t] = r(i)), a;
    });
  }
  json() {
    return this.transform(Ot);
  }
  noUnknown(e = !0, t = ge.noUnknown) {
    typeof e != "boolean" && (t = e, e = !0);
    let s = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: t,
      test(r) {
        if (r == null)
          return !0;
        const i = It(this.schema, r);
        return !e || i.length === 0 || this.createError({
          params: {
            unknown: i.join(", ")
          }
        });
      }
    });
    return s.spec.noUnknown = e, s;
  }
  unknown(e = !0, t = ge.noUnknown) {
    return this.noUnknown(!e, t);
  }
  transformKeys(e) {
    return this.transform((t) => {
      if (!t)
        return t;
      const s = {};
      for (const r of Object.keys(t))
        s[e(r)] = t[r];
      return s;
    });
  }
  camelCase() {
    return this.transformKeys(de.camelCase);
  }
  snakeCase() {
    return this.transformKeys(de.snakeCase);
  }
  constantCase() {
    return this.transformKeys((e) => de.snakeCase(e).toUpperCase());
  }
  describe(e) {
    let t = super.describe(e);
    t.fields = {};
    for (const [r, i] of Object.entries(this.fields)) {
      var s;
      let a = e;
      (s = a) != null && s.value && (a = Object.assign({}, a, {
        parent: a.value,
        value: a.value[r]
      })), t.fields[r] = i.describe(a);
    }
    return t;
  }
}
qe.prototype = He.prototype;
function H(n, e) {
  if (n == null)
    return {};
  var t = {}, s = Object.keys(n), r, i;
  for (i = 0; i < s.length; i++)
    r = s[i], !(e.indexOf(r) >= 0) && (t[r] = n[r]);
  return t;
}
class m {
  constructor(e) {
    Object.assign(this, {
      inserted: "",
      rawInserted: "",
      skip: !1,
      tailShift: 0
    }, e);
  }
  aggregate(e) {
    return this.rawInserted += e.rawInserted, this.skip = this.skip || e.skip, this.inserted += e.inserted, this.tailShift += e.tailShift, this;
  }
  get offset() {
    return this.tailShift + this.inserted.length;
  }
}
function q(n) {
  return typeof n == "string" || n instanceof String;
}
const h = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function Vt(n) {
  switch (n) {
    case h.LEFT:
      return h.FORCE_LEFT;
    case h.RIGHT:
      return h.FORCE_RIGHT;
    default:
      return n;
  }
}
function fe(n) {
  return n.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
}
function J(n) {
  return Array.isArray(n) ? n : [n, new m()];
}
function re(n, e) {
  if (e === n)
    return !0;
  var t = Array.isArray(e), s = Array.isArray(n), r;
  if (t && s) {
    if (e.length != n.length)
      return !1;
    for (r = 0; r < e.length; r++)
      if (!re(e[r], n[r]))
        return !1;
    return !0;
  }
  if (t != s)
    return !1;
  if (e && n && typeof e == "object" && typeof n == "object") {
    var i = e instanceof Date, a = n instanceof Date;
    if (i && a)
      return e.getTime() == n.getTime();
    if (i != a)
      return !1;
    var u = e instanceof RegExp, o = n instanceof RegExp;
    if (u && o)
      return e.toString() == n.toString();
    if (u != o)
      return !1;
    var l = Object.keys(e);
    for (r = 0; r < l.length; r++)
      if (!Object.prototype.hasOwnProperty.call(n, l[r]))
        return !1;
    for (r = 0; r < l.length; r++)
      if (!re(n[l[r]], e[l[r]]))
        return !1;
    return !0;
  } else if (e && n && typeof e == "function" && typeof n == "function")
    return e.toString() === n.toString();
  return !1;
}
class $t {
  constructor(e, t, s, r) {
    for (this.value = e, this.cursorPos = t, this.oldValue = s, this.oldSelection = r; this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos); )
      --this.oldSelection.start;
  }
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }
  get removedCount() {
    return Math.max(this.oldSelection.end - this.startChangePos || this.oldValue.length - this.value.length, 0);
  }
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }
  get head() {
    return this.value.substring(0, this.startChangePos);
  }
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }
  get removeDirection() {
    return !this.removedCount || this.insertedCount ? h.NONE : (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && this.oldSelection.end === this.oldSelection.start ? h.RIGHT : h.LEFT;
  }
}
class w {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, s = arguments.length > 2 ? arguments[2] : void 0;
    this.value = e, this.from = t, this.stop = s;
  }
  toString() {
    return this.value;
  }
  extend(e) {
    this.value += String(e);
  }
  appendTo(e) {
    return e.append(this.toString(), {
      tail: !0
    }).aggregate(e._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  unshift(e) {
    if (!this.value.length || e != null && this.from >= e)
      return "";
    const t = this.value[0];
    return this.value = this.value.slice(1), t;
  }
  shift() {
    if (!this.value.length)
      return "";
    const e = this.value[this.value.length - 1];
    return this.value = this.value.slice(0, -1), e;
  }
}
function f(n) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new f.InputMask(n, e);
}
class b {
  constructor(e) {
    this._value = "", this._update(Object.assign({}, b.DEFAULTS, e)), this.isInitialized = !0;
  }
  updateOptions(e) {
    !Object.keys(e).length || this.withValueRefresh(this._update.bind(this, e));
  }
  _update(e) {
    Object.assign(this, e);
  }
  get state() {
    return {
      _value: this.value
    };
  }
  set state(e) {
    this._value = e._value;
  }
  reset() {
    this._value = "";
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this.resolve(e);
  }
  resolve(e) {
    return this.reset(), this.append(e, {
      input: !0
    }, ""), this.doCommit(), this.value;
  }
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(e) {
    this.reset(), this.append(e, {}, ""), this.doCommit();
  }
  get typedValue() {
    return this.doParse(this.value);
  }
  set typedValue(e) {
    this.value = this.doFormat(e);
  }
  get rawInputValue() {
    return this.extractInput(0, this.value.length, {
      raw: !0
    });
  }
  set rawInputValue(e) {
    this.reset(), this.append(e, {
      raw: !0
    }, ""), this.doCommit();
  }
  get displayValue() {
    return this.value;
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return this.isComplete;
  }
  nearestInputPos(e, t) {
    return e;
  }
  extractInput() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return this.value.slice(e, t);
  }
  extractTail() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return new w(this.extractInput(e, t), e);
  }
  appendTail(e) {
    return q(e) && (e = new w(String(e))), e.appendTo(this);
  }
  _appendCharRaw(e) {
    return e ? (this._value += e, new m({
      inserted: e,
      rawInserted: e
    })) : new m();
  }
  _appendChar(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = arguments.length > 2 ? arguments[2] : void 0;
    const r = this.state;
    let i;
    if ([e, i] = J(this.doPrepare(e, t)), i = i.aggregate(this._appendCharRaw(e, t)), i.inserted) {
      let a, u = this.doValidate(t) !== !1;
      if (u && s != null) {
        const o = this.state;
        this.overwrite === !0 && (a = s.state, s.unshift(this.value.length - i.tailShift));
        let l = this.appendTail(s);
        u = l.rawInserted === s.toString(), !(u && l.inserted) && this.overwrite === "shift" && (this.state = o, a = s.state, s.shift(), l = this.appendTail(s), u = l.rawInserted === s.toString()), u && l.inserted && (this.state = o);
      }
      u || (i = new m(), this.state = r, s && a && (s.state = a));
    }
    return i;
  }
  _appendPlaceholder() {
    return new m();
  }
  _appendEager() {
    return new m();
  }
  append(e, t, s) {
    if (!q(e))
      throw new Error("value should be string");
    const r = new m(), i = q(s) ? new w(String(s)) : s;
    t != null && t.tail && (t._beforeTailState = this.state);
    for (let a = 0; a < e.length; ++a) {
      const u = this._appendChar(e[a], t, i);
      if (!u.rawInserted && !this.doSkipInvalid(e[a], t, i))
        break;
      r.aggregate(u);
    }
    return i != null && (r.tailShift += this.appendTail(i).tailShift), (this.eager === !0 || this.eager === "append") && t !== null && t !== void 0 && t.input && e && r.aggregate(this._appendEager()), r;
  }
  remove() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return this._value = this.value.slice(0, e) + this.value.slice(t), new m();
  }
  withValueRefresh(e) {
    if (this._refreshing || !this.isInitialized)
      return e();
    this._refreshing = !0;
    const t = this.rawInputValue, s = this.value, r = e();
    return this.rawInputValue = t, this.value && this.value !== s && s.indexOf(this.value) === 0 && this.append(s.slice(this.value.length), {}, ""), delete this._refreshing, r;
  }
  runIsolated(e) {
    if (this._isolated || !this.isInitialized)
      return e(this);
    this._isolated = !0;
    const t = this.state, s = e(this);
    return this.state = t, delete this._isolated, s;
  }
  doSkipInvalid(e) {
    return this.skipInvalid;
  }
  doPrepare(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.prepare ? this.prepare(e, this, t) : e;
  }
  doValidate(e) {
    return (!this.validate || this.validate(this.value, this, e)) && (!this.parent || this.parent.doValidate(e));
  }
  doCommit() {
    this.commit && this.commit(this.value, this);
  }
  doFormat(e) {
    return this.format ? this.format(e, this) : e;
  }
  doParse(e) {
    return this.parse ? this.parse(e, this) : e;
  }
  splice(e, t, s, r) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      input: !0
    };
    const a = e + t, u = this.extractTail(a), o = this.eager === !0 || this.eager === "remove";
    let l;
    o && (r = Vt(r), l = this.extractInput(0, a, {
      raw: !0
    }));
    let c = e;
    const d = new m();
    if (r !== h.NONE && (c = this.nearestInputPos(e, t > 1 && e !== 0 && !o ? h.NONE : r), d.tailShift = c - e), d.aggregate(this.remove(c)), o && r !== h.NONE && l === this.rawInputValue)
      if (r === h.FORCE_LEFT) {
        let p;
        for (; l === this.rawInputValue && (p = this.value.length); )
          d.aggregate(new m({
            tailShift: -1
          })).aggregate(this.remove(p - 1));
      } else
        r === h.FORCE_RIGHT && u.unshift();
    return d.aggregate(this.append(s, i, u));
  }
  maskEquals(e) {
    return this.mask === e;
  }
  typedValueEquals(e) {
    const t = this.typedValue;
    return e === t || b.EMPTY_VALUES.includes(e) && b.EMPTY_VALUES.includes(t) || this.doFormat(e) === this.doFormat(this.typedValue);
  }
}
b.DEFAULTS = {
  format: String,
  parse: (n) => n,
  skipInvalid: !0
};
b.EMPTY_VALUES = [void 0, null, ""];
f.Masked = b;
function ze(n) {
  if (n == null)
    throw new Error("mask property should be defined");
  return n instanceof RegExp ? f.MaskedRegExp : q(n) ? f.MaskedPattern : n instanceof Date || n === Date ? f.MaskedDate : n instanceof Number || typeof n == "number" || n === Number ? f.MaskedNumber : Array.isArray(n) || n === Array ? f.MaskedDynamic : f.Masked && n.prototype instanceof f.Masked ? n : n instanceof f.Masked ? n.constructor : n instanceof Function ? f.MaskedFunction : (console.warn("Mask not found for mask", n), f.Masked);
}
function $(n) {
  if (f.Masked && n instanceof f.Masked)
    return n;
  n = Object.assign({}, n);
  const e = n.mask;
  if (f.Masked && e instanceof f.Masked)
    return e;
  const t = ze(e);
  if (!t)
    throw new Error("Masked class is not found for provided mask, appropriate module needs to be import manually before creating mask.");
  return new t(n);
}
f.createMask = $;
const Pt = ["parent", "isOptional", "placeholderChar", "displayChar", "lazy", "eager"], Rt = {
  0: /\d/,
  a: /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  "*": /./
};
class Ge {
  constructor(e) {
    const {
      parent: t,
      isOptional: s,
      placeholderChar: r,
      displayChar: i,
      lazy: a,
      eager: u
    } = e, o = H(e, Pt);
    this.masked = $(o), Object.assign(this, {
      parent: t,
      isOptional: s,
      placeholderChar: r,
      displayChar: i,
      lazy: a,
      eager: u
    });
  }
  reset() {
    this.isFilled = !1, this.masked.reset();
  }
  remove() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return e === 0 && t >= 1 ? (this.isFilled = !1, this.masked.remove(e, t)) : new m();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get displayValue() {
    return this.masked.value && this.displayChar || this.value;
  }
  get isComplete() {
    return Boolean(this.masked.value) || this.isOptional;
  }
  _appendChar(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.isFilled)
      return new m();
    const s = this.masked.state, r = this.masked._appendChar(e, t);
    return r.inserted && this.doValidate(t) === !1 && (r.inserted = r.rawInserted = "", this.masked.state = s), !r.inserted && !this.isOptional && !this.lazy && !t.input && (r.inserted = this.placeholderChar), r.skip = !r.inserted && !this.isOptional, this.isFilled = Boolean(r.inserted), r;
  }
  append() {
    return this.masked.append(...arguments);
  }
  _appendPlaceholder() {
    const e = new m();
    return this.isFilled || this.isOptional || (this.isFilled = !0, e.inserted = this.placeholderChar), e;
  }
  _appendEager() {
    return new m();
  }
  extractTail() {
    return this.masked.extractTail(...arguments);
  }
  appendTail() {
    return this.masked.appendTail(...arguments);
  }
  extractInput() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, s = arguments.length > 2 ? arguments[2] : void 0;
    return this.masked.extractInput(e, t, s);
  }
  nearestInputPos(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : h.NONE;
    const s = 0, r = this.value.length, i = Math.min(Math.max(e, s), r);
    switch (t) {
      case h.LEFT:
      case h.FORCE_LEFT:
        return this.isComplete ? i : s;
      case h.RIGHT:
      case h.FORCE_RIGHT:
        return this.isComplete ? i : r;
      case h.NONE:
      default:
        return i;
    }
  }
  doValidate() {
    return this.masked.doValidate(...arguments) && (!this.parent || this.parent.doValidate(...arguments));
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      masked: this.masked.state,
      isFilled: this.isFilled
    };
  }
  set state(e) {
    this.masked.state = e.masked, this.isFilled = e.isFilled;
  }
}
class Ye {
  constructor(e) {
    Object.assign(this, e), this._value = "", this.isFixed = !0;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : "";
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = !1, this._value = "";
  }
  remove() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length;
    return this._value = this._value.slice(0, e) + this._value.slice(t), this._value || (this._isRawInput = !1), new m();
  }
  nearestInputPos(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : h.NONE;
    const s = 0, r = this._value.length;
    switch (t) {
      case h.LEFT:
      case h.FORCE_LEFT:
        return s;
      case h.NONE:
      case h.RIGHT:
      case h.FORCE_RIGHT:
      default:
        return r;
    }
  }
  extractInput() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length;
    return (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).raw && this._isRawInput && this._value.slice(e, t) || "";
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return Boolean(this._value);
  }
  _appendChar(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const s = new m();
    if (this._value)
      return s;
    const r = this.eager === !0 || this.eager === "append", a = this.char === e && (this.isUnmasking || t.input || t.raw) && (!t.raw || !r) && !t.tail;
    return a && (s.rawInserted = this.char), this._value = s.inserted = this.char, this._isRawInput = a && (t.raw || t.input), s;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: !0
    });
  }
  _appendPlaceholder() {
    const e = new m();
    return this._value || (this._value = e.inserted = this.char), e;
  }
  extractTail() {
    return arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, new w("");
  }
  appendTail(e) {
    return q(e) && (e = new w(String(e))), e.appendTo(this);
  }
  append(e, t, s) {
    const r = this._appendChar(e[0], t);
    return s != null && (r.tailShift += this.appendTail(s).tailShift), r;
  }
  doCommit() {
  }
  get state() {
    return {
      _value: this._value,
      _isRawInput: this._isRawInput
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
}
const jt = ["chunks"];
class I {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    this.chunks = e, this.from = t;
  }
  toString() {
    return this.chunks.map(String).join("");
  }
  extend(e) {
    if (!String(e))
      return;
    q(e) && (e = new w(String(e)));
    const t = this.chunks[this.chunks.length - 1], s = t && (t.stop === e.stop || e.stop == null) && e.from === t.from + t.toString().length;
    if (e instanceof w)
      s ? t.extend(e.toString()) : this.chunks.push(e);
    else if (e instanceof I) {
      if (e.stop == null) {
        let r;
        for (; e.chunks.length && e.chunks[0].stop == null; )
          r = e.chunks.shift(), r.from += e.from, this.extend(r);
      }
      e.toString() && (e.stop = e.blockIndex, this.chunks.push(e));
    }
  }
  appendTo(e) {
    if (!(e instanceof f.MaskedPattern))
      return new w(this.toString()).appendTo(e);
    const t = new m();
    for (let s = 0; s < this.chunks.length && !t.skip; ++s) {
      const r = this.chunks[s], i = e._mapPosToBlock(e.value.length), a = r.stop;
      let u;
      if (a != null && (!i || i.index <= a) && ((r instanceof I || e._stops.indexOf(a) >= 0) && t.aggregate(e._appendPlaceholder(a)), u = r instanceof I && e._blocks[a]), u) {
        const o = u.appendTail(r);
        o.skip = !1, t.aggregate(o), e._value += o.inserted;
        const l = r.toString().slice(o.rawInserted.length);
        l && t.aggregate(e.append(l, {
          tail: !0
        }));
      } else
        t.aggregate(e.append(r.toString(), {
          tail: !0
        }));
    }
    return t;
  }
  get state() {
    return {
      chunks: this.chunks.map((e) => e.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(e) {
    const {
      chunks: t
    } = e, s = H(e, jt);
    Object.assign(this, s), this.chunks = t.map((r) => {
      const i = "chunks" in r ? new I() : new w();
      return i.state = r, i;
    });
  }
  unshift(e) {
    if (!this.chunks.length || e != null && this.from >= e)
      return "";
    const t = e != null ? e - this.from : e;
    let s = 0;
    for (; s < this.chunks.length; ) {
      const r = this.chunks[s], i = r.unshift(t);
      if (r.toString()) {
        if (!i)
          break;
        ++s;
      } else
        this.chunks.splice(s, 1);
      if (i)
        return i;
    }
    return "";
  }
  shift() {
    if (!this.chunks.length)
      return "";
    let e = this.chunks.length - 1;
    for (; 0 <= e; ) {
      const t = this.chunks[e], s = t.shift();
      if (t.toString()) {
        if (!s)
          break;
        --e;
      } else
        this.chunks.splice(e, 1);
      if (s)
        return s;
    }
    return "";
  }
}
class Lt {
  constructor(e, t) {
    this.masked = e, this._log = [];
    const {
      offset: s,
      index: r
    } = e._mapPosToBlock(t) || (t < 0 ? {
      index: 0,
      offset: 0
    } : {
      index: this.masked._blocks.length,
      offset: 0
    });
    this.offset = s, this.index = r, this.ok = !1;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const e = this._log.pop();
    return this.state = e, e;
  }
  bindBlock() {
    this.block || (this.index < 0 && (this.index = 0, this.offset = 0), this.index >= this.masked._blocks.length && (this.index = this.masked._blocks.length - 1, this.offset = this.block.value.length));
  }
  _pushLeft(e) {
    for (this.pushState(), this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((t = this.block) === null || t === void 0 ? void 0 : t.value.length) || 0) {
      var t;
      if (e())
        return this.ok = !0;
    }
    return this.ok = !1;
  }
  _pushRight(e) {
    for (this.pushState(), this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0)
      if (e())
        return this.ok = !0;
    return this.ok = !1;
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, h.FORCE_LEFT), this.offset !== 0))
        return !0;
    });
  }
  pushLeftBeforeInput() {
    return this._pushLeft(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, h.LEFT), !0;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, h.LEFT), !0;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, h.FORCE_RIGHT), this.offset !== this.block.value.length))
        return !0;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, h.NONE), !0;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, h.NONE), !0;
    });
  }
}
class Nt extends b {
  _update(e) {
    e.mask && (e.validate = (t) => t.search(e.mask) >= 0), super._update(e);
  }
}
f.MaskedRegExp = Nt;
const Ut = ["_blocks"];
class y extends b {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.definitions = Object.assign({}, Rt, e.definitions), super(Object.assign({}, y.DEFAULTS, e));
  }
  _update() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.definitions = Object.assign({}, this.definitions, e.definitions), super._update(e), this._rebuildMask();
  }
  _rebuildMask() {
    const e = this.definitions;
    this._blocks = [], this._stops = [], this._maskedBlocks = {};
    let t = this.mask;
    if (!t || !e)
      return;
    let s = !1, r = !1;
    for (let u = 0; u < t.length; ++u) {
      var i, a;
      if (this.blocks) {
        const p = t.slice(u), v = Object.keys(this.blocks).filter((k) => p.indexOf(k) === 0);
        v.sort((k, C) => C.length - k.length);
        const _ = v[0];
        if (_) {
          const k = $(Object.assign({
            parent: this,
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            overwrite: this.overwrite
          }, this.blocks[_]));
          k && (this._blocks.push(k), this._maskedBlocks[_] || (this._maskedBlocks[_] = []), this._maskedBlocks[_].push(this._blocks.length - 1)), u += _.length - 1;
          continue;
        }
      }
      let o = t[u], l = o in e;
      if (o === y.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (o === "{" || o === "}") {
        s = !s;
        continue;
      }
      if (o === "[" || o === "]") {
        r = !r;
        continue;
      }
      if (o === y.ESCAPE_CHAR) {
        if (++u, o = t[u], !o)
          break;
        l = !1;
      }
      const c = (i = e[o]) !== null && i !== void 0 && i.mask && !(((a = e[o]) === null || a === void 0 ? void 0 : a.mask.prototype) instanceof f.Masked) ? e[o] : {
        mask: e[o]
      }, d = l ? new Ge(Object.assign({
        parent: this,
        isOptional: r,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar
      }, c)) : new Ye({
        char: o,
        eager: this.eager,
        isUnmasking: s
      });
      this._blocks.push(d);
    }
  }
  get state() {
    return Object.assign({}, super.state, {
      _blocks: this._blocks.map((e) => e.state)
    });
  }
  set state(e) {
    const {
      _blocks: t
    } = e, s = H(e, Ut);
    this._blocks.forEach((r, i) => r.state = t[i]), super.state = s;
  }
  reset() {
    super.reset(), this._blocks.forEach((e) => e.reset());
  }
  get isComplete() {
    return this._blocks.every((e) => e.isComplete);
  }
  get isFilled() {
    return this._blocks.every((e) => e.isFilled);
  }
  get isFixed() {
    return this._blocks.every((e) => e.isFixed);
  }
  get isOptional() {
    return this._blocks.every((e) => e.isOptional);
  }
  doCommit() {
    this._blocks.forEach((e) => e.doCommit()), super.doCommit();
  }
  get unmaskedValue() {
    return this._blocks.reduce((e, t) => e += t.unmaskedValue, "");
  }
  set unmaskedValue(e) {
    super.unmaskedValue = e;
  }
  get value() {
    return this._blocks.reduce((e, t) => e += t.value, "");
  }
  set value(e) {
    super.value = e;
  }
  get displayValue() {
    return this._blocks.reduce((e, t) => e += t.displayValue, "");
  }
  appendTail(e) {
    return super.appendTail(e).aggregate(this._appendPlaceholder());
  }
  _appendEager() {
    var e;
    const t = new m();
    let s = (e = this._mapPosToBlock(this.value.length)) === null || e === void 0 ? void 0 : e.index;
    if (s == null)
      return t;
    this._blocks[s].isFilled && ++s;
    for (let r = s; r < this._blocks.length; ++r) {
      const i = this._blocks[r]._appendEager();
      if (!i.inserted)
        break;
      t.aggregate(i);
    }
    return t;
  }
  _appendCharRaw(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const s = this._mapPosToBlock(this.value.length), r = new m();
    if (!s)
      return r;
    for (let u = s.index; ; ++u) {
      var i, a;
      const o = this._blocks[u];
      if (!o)
        break;
      const l = o._appendChar(e, Object.assign({}, t, {
        _beforeTailState: (i = t._beforeTailState) === null || i === void 0 || (a = i._blocks) === null || a === void 0 ? void 0 : a[u]
      })), c = l.skip;
      if (r.aggregate(l), c || l.rawInserted)
        break;
    }
    return r;
  }
  extractTail() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    const s = new I();
    return e === t || this._forEachBlocksInRange(e, t, (r, i, a, u) => {
      const o = r.extractTail(a, u);
      o.stop = this._findStopBefore(i), o.from = this._blockStartPos(i), o instanceof I && (o.blockIndex = i), s.extend(o);
    }), s;
  }
  extractInput() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (e === t)
      return "";
    let r = "";
    return this._forEachBlocksInRange(e, t, (i, a, u, o) => {
      r += i.extractInput(u, o, s);
    }), r;
  }
  _findStopBefore(e) {
    let t;
    for (let s = 0; s < this._stops.length; ++s) {
      const r = this._stops[s];
      if (r <= e)
        t = r;
      else
        break;
    }
    return t;
  }
  _appendPlaceholder(e) {
    const t = new m();
    if (this.lazy && e == null)
      return t;
    const s = this._mapPosToBlock(this.value.length);
    if (!s)
      return t;
    const r = s.index, i = e != null ? e : this._blocks.length;
    return this._blocks.slice(r, i).forEach((a) => {
      if (!a.lazy || e != null) {
        const u = a._blocks != null ? [a._blocks.length] : [], o = a._appendPlaceholder(...u);
        this._value += o.inserted, t.aggregate(o);
      }
    }), t;
  }
  _mapPosToBlock(e) {
    let t = "";
    for (let s = 0; s < this._blocks.length; ++s) {
      const r = this._blocks[s], i = t.length;
      if (t += r.value, e <= t.length)
        return {
          index: s,
          offset: e - i
        };
    }
  }
  _blockStartPos(e) {
    return this._blocks.slice(0, e).reduce((t, s) => t += s.value.length, 0);
  }
  _forEachBlocksInRange(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, s = arguments.length > 2 ? arguments[2] : void 0;
    const r = this._mapPosToBlock(e);
    if (r) {
      const i = this._mapPosToBlock(t), a = i && r.index === i.index, u = r.offset, o = i && a ? i.offset : this._blocks[r.index].value.length;
      if (s(this._blocks[r.index], r.index, u, o), i && !a) {
        for (let l = r.index + 1; l < i.index; ++l)
          s(this._blocks[l], l, 0, this._blocks[l].value.length);
        s(this._blocks[i.index], i.index, 0, i.offset);
      }
    }
  }
  remove() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    const s = super.remove(e, t);
    return this._forEachBlocksInRange(e, t, (r, i, a, u) => {
      s.aggregate(r.remove(a, u));
    }), s;
  }
  nearestInputPos(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : h.NONE;
    if (!this._blocks.length)
      return 0;
    const s = new Lt(this, e);
    if (t === h.NONE)
      return s.pushRightBeforeInput() || (s.popState(), s.pushLeftBeforeInput()) ? s.pos : this.value.length;
    if (t === h.LEFT || t === h.FORCE_LEFT) {
      if (t === h.LEFT) {
        if (s.pushRightBeforeFilled(), s.ok && s.pos === e)
          return e;
        s.popState();
      }
      if (s.pushLeftBeforeInput(), s.pushLeftBeforeRequired(), s.pushLeftBeforeFilled(), t === h.LEFT) {
        if (s.pushRightBeforeInput(), s.pushRightBeforeRequired(), s.ok && s.pos <= e || (s.popState(), s.ok && s.pos <= e))
          return s.pos;
        s.popState();
      }
      return s.ok ? s.pos : t === h.FORCE_LEFT ? 0 : (s.popState(), s.ok || (s.popState(), s.ok) ? s.pos : 0);
    }
    return t === h.RIGHT || t === h.FORCE_RIGHT ? (s.pushRightBeforeInput(), s.pushRightBeforeRequired(), s.pushRightBeforeFilled() ? s.pos : t === h.FORCE_RIGHT ? this.value.length : (s.popState(), s.ok || (s.popState(), s.ok) ? s.pos : this.nearestInputPos(e, h.LEFT))) : e;
  }
  maskedBlock(e) {
    return this.maskedBlocks(e)[0];
  }
  maskedBlocks(e) {
    const t = this._maskedBlocks[e];
    return t ? t.map((s) => this._blocks[s]) : [];
  }
}
y.DEFAULTS = {
  lazy: !0,
  placeholderChar: "_"
};
y.STOP_CHAR = "`";
y.ESCAPE_CHAR = "\\";
y.InputDefinition = Ge;
y.FixedDefinition = Ye;
f.MaskedPattern = y;
class ee extends y {
  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  _update(e) {
    e = Object.assign({
      to: this.to || 0,
      from: this.from || 0,
      maxLength: this.maxLength || 0
    }, e);
    let t = String(e.to).length;
    e.maxLength != null && (t = Math.max(t, e.maxLength)), e.maxLength = t;
    const s = String(e.from).padStart(t, "0"), r = String(e.to).padStart(t, "0");
    let i = 0;
    for (; i < r.length && r[i] === s[i]; )
      ++i;
    e.mask = r.slice(0, i).replace(/0/g, "\\0") + "0".repeat(t - i), super._update(e);
  }
  get isComplete() {
    return super.isComplete && Boolean(this.value);
  }
  boundaries(e) {
    let t = "", s = "";
    const [, r, i] = e.match(/^(\D*)(\d*)(\D*)/) || [];
    return i && (t = "0".repeat(r.length) + i, s = "9".repeat(r.length) + i), t = t.padEnd(this.maxLength, "0"), s = s.padEnd(this.maxLength, "9"), [t, s];
  }
  doPrepare(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s;
    if ([e, s] = J(super.doPrepare(e.replace(/\D/g, ""), t)), !this.autofix || !e)
      return e;
    const r = String(this.from).padStart(this.maxLength, "0"), i = String(this.to).padStart(this.maxLength, "0");
    let a = this.value + e;
    if (a.length > this.maxLength)
      return "";
    const [u, o] = this.boundaries(a);
    return Number(o) < this.from ? r[a.length - 1] : Number(u) > this.to ? this.autofix === "pad" && a.length < this.maxLength ? ["", s.aggregate(this.append(r[a.length - 1] + e, t))] : i[a.length - 1] : e;
  }
  doValidate() {
    const e = this.value;
    if (e.search(/[^0]/) === -1 && e.length <= this._matchFrom)
      return !0;
    const [s, r] = this.boundaries(e);
    return this.from <= Number(r) && Number(s) <= this.to && super.doValidate(...arguments);
  }
}
f.MaskedRange = ee;
class z extends y {
  constructor(e) {
    super(Object.assign({}, z.DEFAULTS, e));
  }
  _update(e) {
    e.mask === Date && delete e.mask, e.pattern && (e.mask = e.pattern);
    const t = e.blocks;
    e.blocks = Object.assign({}, z.GET_DEFAULT_BLOCKS()), e.min && (e.blocks.Y.from = e.min.getFullYear()), e.max && (e.blocks.Y.to = e.max.getFullYear()), e.min && e.max && e.blocks.Y.from === e.blocks.Y.to && (e.blocks.m.from = e.min.getMonth() + 1, e.blocks.m.to = e.max.getMonth() + 1, e.blocks.m.from === e.blocks.m.to && (e.blocks.d.from = e.min.getDate(), e.blocks.d.to = e.max.getDate())), Object.assign(e.blocks, this.blocks, t), Object.keys(e.blocks).forEach((s) => {
      const r = e.blocks[s];
      !("autofix" in r) && "autofix" in e && (r.autofix = e.autofix);
    }), super._update(e);
  }
  doValidate() {
    const e = this.date;
    return super.doValidate(...arguments) && (!this.isComplete || this.isDateExist(this.value) && e != null && (this.min == null || this.min <= e) && (this.max == null || e <= this.max));
  }
  isDateExist(e) {
    return this.format(this.parse(e, this), this).indexOf(e) >= 0;
  }
  get date() {
    return this.typedValue;
  }
  set date(e) {
    this.typedValue = e;
  }
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(e) {
    super.typedValue = e;
  }
  maskEquals(e) {
    return e === Date || super.maskEquals(e);
  }
}
z.DEFAULTS = {
  pattern: "d{.}`m{.}`Y",
  format: (n) => {
    if (!n)
      return "";
    const e = String(n.getDate()).padStart(2, "0"), t = String(n.getMonth() + 1).padStart(2, "0"), s = n.getFullYear();
    return [e, t, s].join(".");
  },
  parse: (n) => {
    const [e, t, s] = n.split(".");
    return new Date(s, t - 1, e);
  }
};
z.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: ee,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: ee,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: ee,
    from: 1900,
    to: 9999
  }
});
f.MaskedDate = z;
class ye {
  get selectionStart() {
    let e;
    try {
      e = this._unsafeSelectionStart;
    } catch {
    }
    return e != null ? e : this.value.length;
  }
  get selectionEnd() {
    let e;
    try {
      e = this._unsafeSelectionEnd;
    } catch {
    }
    return e != null ? e : this.value.length;
  }
  select(e, t) {
    if (!(e == null || t == null || e === this.selectionStart && t === this.selectionEnd))
      try {
        this._unsafeSelect(e, t);
      } catch {
      }
  }
  _unsafeSelect(e, t) {
  }
  get isActive() {
    return !1;
  }
  bindEvents(e) {
  }
  unbindEvents() {
  }
}
f.MaskElement = ye;
class G extends ye {
  constructor(e) {
    super(), this.input = e, this._handlers = {};
  }
  get rootElement() {
    var e, t, s;
    return (e = (t = (s = this.input).getRootNode) === null || t === void 0 ? void 0 : t.call(s)) !== null && e !== void 0 ? e : document;
  }
  get isActive() {
    return this.input === this.rootElement.activeElement;
  }
  get _unsafeSelectionStart() {
    return this.input.selectionStart;
  }
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }
  _unsafeSelect(e, t) {
    this.input.setSelectionRange(e, t);
  }
  get value() {
    return this.input.value;
  }
  set value(e) {
    this.input.value = e;
  }
  bindEvents(e) {
    Object.keys(e).forEach((t) => this._toggleEventHandler(G.EVENTS_MAP[t], e[t]));
  }
  unbindEvents() {
    Object.keys(this._handlers).forEach((e) => this._toggleEventHandler(e));
  }
  _toggleEventHandler(e, t) {
    this._handlers[e] && (this.input.removeEventListener(e, this._handlers[e]), delete this._handlers[e]), t && (this.input.addEventListener(e, t), this._handlers[e] = t);
  }
}
G.EVENTS_MAP = {
  selectionChange: "keydown",
  input: "input",
  drop: "drop",
  click: "click",
  focus: "focus",
  commit: "blur"
};
f.HTMLMaskElement = G;
class Ze extends G {
  get _unsafeSelectionStart() {
    const e = this.rootElement, t = e.getSelection && e.getSelection(), s = t && t.anchorOffset, r = t && t.focusOffset;
    return r == null || s == null || s < r ? s : r;
  }
  get _unsafeSelectionEnd() {
    const e = this.rootElement, t = e.getSelection && e.getSelection(), s = t && t.anchorOffset, r = t && t.focusOffset;
    return r == null || s == null || s > r ? s : r;
  }
  _unsafeSelect(e, t) {
    if (!this.rootElement.createRange)
      return;
    const s = this.rootElement.createRange();
    s.setStart(this.input.firstChild || this.input, e), s.setEnd(this.input.lastChild || this.input, t);
    const r = this.rootElement, i = r.getSelection && r.getSelection();
    i && (i.removeAllRanges(), i.addRange(s));
  }
  get value() {
    return this.input.textContent;
  }
  set value(e) {
    this.input.textContent = e;
  }
}
f.HTMLContenteditableMaskElement = Ze;
const qt = ["mask"];
class Ht {
  constructor(e, t) {
    this.el = e instanceof ye ? e : e.isContentEditable && e.tagName !== "INPUT" && e.tagName !== "TEXTAREA" ? new Ze(e) : new G(e), this.masked = $(t), this._listeners = {}, this._value = "", this._unmaskedValue = "", this._saveSelection = this._saveSelection.bind(this), this._onInput = this._onInput.bind(this), this._onChange = this._onChange.bind(this), this._onDrop = this._onDrop.bind(this), this._onFocus = this._onFocus.bind(this), this._onClick = this._onClick.bind(this), this.alignCursor = this.alignCursor.bind(this), this.alignCursorFriendly = this.alignCursorFriendly.bind(this), this._bindEvents(), this.updateValue(), this._onChange();
  }
  get mask() {
    return this.masked.mask;
  }
  maskEquals(e) {
    var t;
    return e == null || ((t = this.masked) === null || t === void 0 ? void 0 : t.maskEquals(e));
  }
  set mask(e) {
    if (this.maskEquals(e))
      return;
    if (!(e instanceof f.Masked) && this.masked.constructor === ze(e)) {
      this.masked.updateOptions({
        mask: e
      });
      return;
    }
    const t = $({
      mask: e
    });
    t.unmaskedValue = this.masked.unmaskedValue, this.masked = t;
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this.value !== e && (this.masked.value = e, this.updateControl(), this.alignCursor());
  }
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(e) {
    this.unmaskedValue !== e && (this.masked.unmaskedValue = e, this.updateControl(), this.alignCursor());
  }
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(e) {
    this.masked.typedValueEquals(e) || (this.masked.typedValue = e, this.updateControl(), this.alignCursor());
  }
  get displayValue() {
    return this.masked.displayValue;
  }
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange
    });
  }
  _unbindEvents() {
    this.el && this.el.unbindEvents();
  }
  _fireEvent(e) {
    for (var t = arguments.length, s = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
      s[r - 1] = arguments[r];
    const i = this._listeners[e];
    !i || i.forEach((a) => a(...s));
  }
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(e) {
    !this.el || !this.el.isActive || (this.el.select(e, e), this._saveSelection());
  }
  _saveSelection() {
    this.displayValue !== this.el.value && console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."), this._selection = {
      start: this.selectionStart,
      end: this.cursorPos
    };
  }
  updateValue() {
    this.masked.value = this.el.value, this._value = this.masked.value;
  }
  updateControl() {
    const e = this.masked.unmaskedValue, t = this.masked.value, s = this.displayValue, r = this.unmaskedValue !== e || this.value !== t;
    this._unmaskedValue = e, this._value = t, this.el.value !== s && (this.el.value = s), r && this._fireChangeEvents();
  }
  updateOptions(e) {
    const {
      mask: t
    } = e, s = H(e, qt), r = !this.maskEquals(t), i = !re(this.masked, s);
    r && (this.mask = t), i && this.masked.updateOptions(s), (r || i) && this.updateControl();
  }
  updateCursor(e) {
    e != null && (this.cursorPos = e, this._delayUpdateCursor(e));
  }
  _delayUpdateCursor(e) {
    this._abortUpdateCursor(), this._changingCursorPos = e, this._cursorChanging = setTimeout(() => {
      !this.el || (this.cursorPos = this._changingCursorPos, this._abortUpdateCursor());
    }, 10);
  }
  _fireChangeEvents() {
    this._fireEvent("accept", this._inputEvent), this.masked.isComplete && this._fireEvent("complete", this._inputEvent);
  }
  _abortUpdateCursor() {
    this._cursorChanging && (clearTimeout(this._cursorChanging), delete this._cursorChanging);
  }
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, h.LEFT));
  }
  alignCursorFriendly() {
    this.selectionStart === this.cursorPos && this.alignCursor();
  }
  on(e, t) {
    return this._listeners[e] || (this._listeners[e] = []), this._listeners[e].push(t), this;
  }
  off(e, t) {
    if (!this._listeners[e])
      return this;
    if (!t)
      return delete this._listeners[e], this;
    const s = this._listeners[e].indexOf(t);
    return s >= 0 && this._listeners[e].splice(s, 1), this;
  }
  _onInput(e) {
    if (this._inputEvent = e, this._abortUpdateCursor(), !this._selection)
      return this.updateValue();
    const t = new $t(
      this.el.value,
      this.cursorPos,
      this.displayValue,
      this._selection
    ), s = this.masked.rawInputValue, r = this.masked.splice(t.startChangePos, t.removed.length, t.inserted, t.removeDirection, {
      input: !0,
      raw: !0
    }).offset, i = s === this.masked.rawInputValue ? t.removeDirection : h.NONE;
    let a = this.masked.nearestInputPos(t.startChangePos + r, i);
    i !== h.NONE && (a = this.masked.nearestInputPos(a, h.NONE)), this.updateControl(), this.updateCursor(a), delete this._inputEvent;
  }
  _onChange() {
    this.displayValue !== this.el.value && this.updateValue(), this.masked.doCommit(), this.updateControl(), this._saveSelection();
  }
  _onDrop(e) {
    e.preventDefault(), e.stopPropagation();
  }
  _onFocus(e) {
    this.alignCursorFriendly();
  }
  _onClick(e) {
    this.alignCursorFriendly();
  }
  destroy() {
    this._unbindEvents(), this._listeners.length = 0, delete this.el;
  }
}
f.InputMask = Ht;
class zt extends y {
  _update(e) {
    e.enum && (e.mask = "*".repeat(e.enum[0].length)), super._update(e);
  }
  doValidate() {
    return this.enum.some((e) => e.indexOf(this.unmaskedValue) >= 0) && super.doValidate(...arguments);
  }
}
f.MaskedEnum = zt;
class S extends b {
  constructor(e) {
    super(Object.assign({}, S.DEFAULTS, e));
  }
  _update(e) {
    super._update(e), this._updateRegExps();
  }
  _updateRegExps() {
    let e = "^" + (this.allowNegative ? "[+|\\-]?" : ""), t = "\\d*", s = (this.scale ? "(".concat(fe(this.radix), "\\d{0,").concat(this.scale, "})?") : "") + "$";
    this._numberRegExp = new RegExp(e + t + s), this._mapToRadixRegExp = new RegExp("[".concat(this.mapToRadix.map(fe).join(""), "]"), "g"), this._thousandsSeparatorRegExp = new RegExp(fe(this.thousandsSeparator), "g");
  }
  _removeThousandsSeparators(e) {
    return e.replace(this._thousandsSeparatorRegExp, "");
  }
  _insertThousandsSeparators(e) {
    const t = e.split(this.radix);
    return t[0] = t[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator), t.join(this.radix);
  }
  doPrepare(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    e = this._removeThousandsSeparators(this.scale && this.mapToRadix.length && (t.input && t.raw || !t.input && !t.raw) ? e.replace(this._mapToRadixRegExp, this.radix) : e);
    const [s, r] = J(super.doPrepare(e, t));
    return e && !s && (r.skip = !0), [s, r];
  }
  _separatorsCount(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, s = 0;
    for (let r = 0; r < e; ++r)
      this._value.indexOf(this.thousandsSeparator, r) === r && (++s, t && (e += this.thousandsSeparator.length));
    return s;
  }
  _separatorsCountFromSlice() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._value;
    return this._separatorsCount(this._removeThousandsSeparators(e).length, !0);
  }
  extractInput() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, s = arguments.length > 2 ? arguments[2] : void 0;
    return [e, t] = this._adjustRangeWithSeparators(e, t), this._removeThousandsSeparators(super.extractInput(e, t, s));
  }
  _appendCharRaw(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.thousandsSeparator)
      return super._appendCharRaw(e, t);
    const s = t.tail && t._beforeTailState ? t._beforeTailState._value : this._value, r = this._separatorsCountFromSlice(s);
    this._value = this._removeThousandsSeparators(this.value);
    const i = super._appendCharRaw(e, t);
    this._value = this._insertThousandsSeparators(this._value);
    const a = t.tail && t._beforeTailState ? t._beforeTailState._value : this._value, u = this._separatorsCountFromSlice(a);
    return i.tailShift += (u - r) * this.thousandsSeparator.length, i.skip = !i.rawInserted && e === this.thousandsSeparator, i;
  }
  _findSeparatorAround(e) {
    if (this.thousandsSeparator) {
      const t = e - this.thousandsSeparator.length + 1, s = this.value.indexOf(this.thousandsSeparator, t);
      if (s <= e)
        return s;
    }
    return -1;
  }
  _adjustRangeWithSeparators(e, t) {
    const s = this._findSeparatorAround(e);
    s >= 0 && (e = s);
    const r = this._findSeparatorAround(t);
    return r >= 0 && (t = r + this.thousandsSeparator.length), [e, t];
  }
  remove() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    [e, t] = this._adjustRangeWithSeparators(e, t);
    const s = this.value.slice(0, e), r = this.value.slice(t), i = this._separatorsCount(s.length);
    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(s + r));
    const a = this._separatorsCountFromSlice(s);
    return new m({
      tailShift: (a - i) * this.thousandsSeparator.length
    });
  }
  nearestInputPos(e, t) {
    if (!this.thousandsSeparator)
      return e;
    switch (t) {
      case h.NONE:
      case h.LEFT:
      case h.FORCE_LEFT: {
        const s = this._findSeparatorAround(e - 1);
        if (s >= 0) {
          const r = s + this.thousandsSeparator.length;
          if (e < r || this.value.length <= r || t === h.FORCE_LEFT)
            return s;
        }
        break;
      }
      case h.RIGHT:
      case h.FORCE_RIGHT: {
        const s = this._findSeparatorAround(e);
        if (s >= 0)
          return s + this.thousandsSeparator.length;
      }
    }
    return e;
  }
  doValidate(e) {
    let t = Boolean(this._removeThousandsSeparators(this.value).match(this._numberRegExp));
    if (t) {
      const s = this.number;
      t = t && !isNaN(s) && (this.min == null || this.min >= 0 || this.min <= this.number) && (this.max == null || this.max <= 0 || this.number <= this.max);
    }
    return t && super.doValidate(e);
  }
  doCommit() {
    if (this.value) {
      const e = this.number;
      let t = e;
      this.min != null && (t = Math.max(t, this.min)), this.max != null && (t = Math.min(t, this.max)), t !== e && (this.unmaskedValue = this.doFormat(t));
      let s = this.value;
      this.normalizeZeros && (s = this._normalizeZeros(s)), this.padFractionalZeros && this.scale > 0 && (s = this._padFractionalZeros(s)), this._value = s;
    }
    super.doCommit();
  }
  _normalizeZeros(e) {
    const t = this._removeThousandsSeparators(e).split(this.radix);
    return t[0] = t[0].replace(/^(\D*)(0*)(\d*)/, (s, r, i, a) => r + a), e.length && !/\d$/.test(t[0]) && (t[0] = t[0] + "0"), t.length > 1 && (t[1] = t[1].replace(/0*$/, ""), t[1].length || (t.length = 1)), this._insertThousandsSeparators(t.join(this.radix));
  }
  _padFractionalZeros(e) {
    if (!e)
      return e;
    const t = e.split(this.radix);
    return t.length < 2 && t.push(""), t[1] = t[1].padEnd(this.scale, "0"), t.join(this.radix);
  }
  doSkipInvalid(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = arguments.length > 2 ? arguments[2] : void 0;
    const r = this.scale === 0 && e !== this.thousandsSeparator && (e === this.radix || e === S.UNMASKED_RADIX || this.mapToRadix.includes(e));
    return super.doSkipInvalid(e, t, s) && !r;
  }
  get unmaskedValue() {
    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, S.UNMASKED_RADIX);
  }
  set unmaskedValue(e) {
    super.unmaskedValue = e;
  }
  get typedValue() {
    return this.doParse(this.unmaskedValue);
  }
  set typedValue(e) {
    this.rawInputValue = this.doFormat(e).replace(S.UNMASKED_RADIX, this.radix);
  }
  get number() {
    return this.typedValue;
  }
  set number(e) {
    this.typedValue = e;
  }
  get allowNegative() {
    return this.signed || this.min != null && this.min < 0 || this.max != null && this.max < 0;
  }
  typedValueEquals(e) {
    return (super.typedValueEquals(e) || S.EMPTY_VALUES.includes(e) && S.EMPTY_VALUES.includes(this.typedValue)) && !(e === 0 && this.value === "");
  }
}
S.UNMASKED_RADIX = ".";
S.DEFAULTS = {
  radix: ",",
  thousandsSeparator: "",
  mapToRadix: [S.UNMASKED_RADIX],
  scale: 2,
  signed: !1,
  normalizeZeros: !0,
  padFractionalZeros: !1,
  parse: Number,
  format: (n) => n.toLocaleString("en-US", {
    useGrouping: !1,
    maximumFractionDigits: 20
  })
};
S.EMPTY_VALUES = [...b.EMPTY_VALUES, 0];
f.MaskedNumber = S;
class Gt extends b {
  _update(e) {
    e.mask && (e.validate = e.mask), super._update(e);
  }
}
f.MaskedFunction = Gt;
const Yt = ["compiledMasks", "currentMaskRef", "currentMask"], Zt = ["mask"];
class ue extends b {
  constructor(e) {
    super(Object.assign({}, ue.DEFAULTS, e)), this.currentMask = null;
  }
  _update(e) {
    super._update(e), "mask" in e && (this.compiledMasks = Array.isArray(e.mask) ? e.mask.map((t) => $(t)) : []);
  }
  _appendCharRaw(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const s = this._applyDispatch(e, t);
    return this.currentMask && s.aggregate(this.currentMask._appendChar(e, this.currentMaskFlags(t))), s;
  }
  _applyDispatch() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const s = t.tail && t._beforeTailState != null ? t._beforeTailState._value : this.value, r = this.rawInputValue, i = t.tail && t._beforeTailState != null ? t._beforeTailState._rawInputValue : r, a = r.slice(i.length), u = this.currentMask, o = new m(), l = u == null ? void 0 : u.state;
    if (this.currentMask = this.doDispatch(e, Object.assign({}, t)), this.currentMask)
      if (this.currentMask !== u) {
        if (this.currentMask.reset(), i) {
          const c = this.currentMask.append(i, {
            raw: !0
          });
          o.tailShift = c.inserted.length - s.length;
        }
        a && (o.tailShift += this.currentMask.append(a, {
          raw: !0,
          tail: !0
        }).tailShift);
      } else
        this.currentMask.state = l;
    return o;
  }
  _appendPlaceholder() {
    const e = this._applyDispatch(...arguments);
    return this.currentMask && e.aggregate(this.currentMask._appendPlaceholder()), e;
  }
  _appendEager() {
    const e = this._applyDispatch(...arguments);
    return this.currentMask && e.aggregate(this.currentMask._appendEager()), e;
  }
  currentMaskFlags(e) {
    var t, s;
    return Object.assign({}, e, {
      _beforeTailState: ((t = e._beforeTailState) === null || t === void 0 ? void 0 : t.currentMaskRef) === this.currentMask && ((s = e._beforeTailState) === null || s === void 0 ? void 0 : s.currentMask) || e._beforeTailState
    });
  }
  doDispatch(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.dispatch(e, this, t);
  }
  doValidate(e) {
    return super.doValidate(e) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(e)));
  }
  doPrepare(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, [s, r] = J(super.doPrepare(e, t));
    if (this.currentMask) {
      let i;
      [s, i] = J(super.doPrepare(s, this.currentMaskFlags(t))), r = r.aggregate(i);
    }
    return [s, r];
  }
  reset() {
    var e;
    (e = this.currentMask) === null || e === void 0 || e.reset(), this.compiledMasks.forEach((t) => t.reset());
  }
  get value() {
    return this.currentMask ? this.currentMask.value : "";
  }
  set value(e) {
    super.value = e;
  }
  get unmaskedValue() {
    return this.currentMask ? this.currentMask.unmaskedValue : "";
  }
  set unmaskedValue(e) {
    super.unmaskedValue = e;
  }
  get typedValue() {
    return this.currentMask ? this.currentMask.typedValue : "";
  }
  set typedValue(e) {
    let t = String(e);
    this.currentMask && (this.currentMask.typedValue = e, t = this.currentMask.unmaskedValue), this.unmaskedValue = t;
  }
  get displayValue() {
    return this.currentMask ? this.currentMask.displayValue : "";
  }
  get isComplete() {
    var e;
    return Boolean((e = this.currentMask) === null || e === void 0 ? void 0 : e.isComplete);
  }
  get isFilled() {
    var e;
    return Boolean((e = this.currentMask) === null || e === void 0 ? void 0 : e.isFilled);
  }
  remove() {
    const e = new m();
    return this.currentMask && e.aggregate(this.currentMask.remove(...arguments)).aggregate(this._applyDispatch()), e;
  }
  get state() {
    var e;
    return Object.assign({}, super.state, {
      _rawInputValue: this.rawInputValue,
      compiledMasks: this.compiledMasks.map((t) => t.state),
      currentMaskRef: this.currentMask,
      currentMask: (e = this.currentMask) === null || e === void 0 ? void 0 : e.state
    });
  }
  set state(e) {
    const {
      compiledMasks: t,
      currentMaskRef: s,
      currentMask: r
    } = e, i = H(e, Yt);
    this.compiledMasks.forEach((a, u) => a.state = t[u]), s != null && (this.currentMask = s, this.currentMask.state = r), super.state = i;
  }
  extractInput() {
    return this.currentMask ? this.currentMask.extractInput(...arguments) : "";
  }
  extractTail() {
    return this.currentMask ? this.currentMask.extractTail(...arguments) : super.extractTail(...arguments);
  }
  doCommit() {
    this.currentMask && this.currentMask.doCommit(), super.doCommit();
  }
  nearestInputPos() {
    return this.currentMask ? this.currentMask.nearestInputPos(...arguments) : super.nearestInputPos(...arguments);
  }
  get overwrite() {
    return this.currentMask ? this.currentMask.overwrite : super.overwrite;
  }
  set overwrite(e) {
    console.warn('"overwrite" option is not available in dynamic mask, use this option in siblings');
  }
  get eager() {
    return this.currentMask ? this.currentMask.eager : super.eager;
  }
  set eager(e) {
    console.warn('"eager" option is not available in dynamic mask, use this option in siblings');
  }
  get skipInvalid() {
    return this.currentMask ? this.currentMask.skipInvalid : super.skipInvalid;
  }
  set skipInvalid(e) {
    (this.isInitialized || e !== b.DEFAULTS.skipInvalid) && console.warn('"skipInvalid" option is not available in dynamic mask, use this option in siblings');
  }
  maskEquals(e) {
    return Array.isArray(e) && this.compiledMasks.every((t, s) => {
      if (!e[s])
        return;
      const r = e[s], {
        mask: i
      } = r, a = H(r, Zt);
      return re(t, a) && t.maskEquals(i);
    });
  }
  typedValueEquals(e) {
    var t;
    return Boolean((t = this.currentMask) === null || t === void 0 ? void 0 : t.typedValueEquals(e));
  }
}
ue.DEFAULTS = {
  dispatch: (n, e, t) => {
    if (!e.compiledMasks.length)
      return;
    const s = e.rawInputValue, r = e.compiledMasks.map((i, a) => (i.reset(), i.append(s, {
      raw: !0
    }), i.append(n, e.currentMaskFlags(t)), {
      weight: i.rawInputValue.length,
      index: a
    }));
    return r.sort((i, a) => a.weight - i.weight), e.compiledMasks[r[0].index];
  }
};
f.MaskedDynamic = ue;
const ve = {
  MASKED: "value",
  UNMASKED: "unmaskedValue",
  TYPED: "typedValue"
};
function Ke(n) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ve.MASKED, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ve.MASKED;
  const s = $(n);
  return (r) => s.runIsolated((i) => (i[e] = r, i[t]));
}
function Kt(n) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), s = 1; s < e; s++)
    t[s - 1] = arguments[s];
  return Ke(...t)(n);
}
f.PIPE_TYPE = ve;
f.createPipe = Ke;
f.pipe = Kt;
try {
  globalThis.IMask = f;
} catch {
}
var x, M, O, B;
class Xt {
  constructor(e) {
    X(this, x, void 0);
    X(this, M, void 0);
    X(this, O, void 0);
    X(this, B, void 0);
    var t, s;
    this.classes = {
      valid: "is-valid",
      invalid: "is-invalid",
      error: "has-error",
      serverError: "has-server-error",
      serverSuccess: "has-server-success"
    }, this.$el = e.el, this.params = Object.assign(this.defaults(), e.params), this.$submit = (t = this.$el.querySelector("[me\\:form\\:submit]")) != null ? t : this.$el.querySelector('[type="submit"]'), this.name = (s = e.name) != null ? s : "FormBase", F(this, x, []), this.ajax = this.$el.hasAttribute("ajax") && this.$el.getAttribute("ajax") === "true", this.method = this.$el.hasAttribute("method") ? this.$el.getAttribute("method") : void 0, this.action = this.$el.hasAttribute("action") ? this.$el.getAttribute("action") : void 0, F(this, B, !1), F(this, M, !1), F(this, O, []), this.acceptSendingEmptyValues = !1, this.recaptcha = this.ajax && (!this.$el.hasAttribute("recaptcha") || this.$el.getAttribute("recaptcha") !== "false"), this.recaptcha && (this.recaptchaAction = this.$el.hasAttribute("recaptcha-action") ? this.$el.getAttribute("recaptcha-action") : void 0, this.recaptchaInputName = "g-recaptcha-response", this.$recaptchaInput = this.$el.querySelector(`input[name="${this.recaptchaInputName}"]`)), this.options = {
      debug: window.SETTINGS && SETTINGS.DEBUG_MODE ? SETTINGS.DEBUG_MODE : !1
    }, this.submitHandler = this.submitHandler.bind(this);
  }
  defaults() {
    return {};
  }
  initialize() {
    !this.requirementsExist() || this.addEvents();
  }
  terminate() {
    this.removeEvents();
  }
  addEvents() {
    this.$submit.addEventListener("click", this.submitHandler), this.$el.addEventListener("submit", this.submitHandler);
  }
  removeEvents() {
    this.$submit.removeEventListener("click", this.submitHandler), this.$el.removeEventListener("submit", this.submitHandler);
  }
  addFields(e) {
    if (!Array.isArray(e)) {
      console.error("addFields() must receive an array");
      return;
    }
    e.forEach((t) => {
      this.addField(t);
    });
  }
  addField(e) {
    if (!!this.fieldRequirementsExist(e)) {
      if (this.getField(e.name) !== void 0) {
        console.warn(`Cannot add field named ${e.name} because it already exists`);
        return;
      }
      if (e.$el = this.$el.querySelector(`[name="${e.name}"]`), e.type = this.getFieldType(e.$el), e.type === "select") {
        const t = e.$el.querySelectorAll("option");
        if (t.length) {
          const s = Array.from(t).find((r) => r.hasAttribute("default"));
          e.defaultValue = s !== void 0 ? s.value : t[0].value;
        }
      }
      e.maskOptions && (e.mask = f(e.$el, e.maskOptions)), E(this, x).push(e);
    }
  }
  getFieldType(e) {
    const t = e.tagName.toLowerCase();
    return t === "input" ? e.hasAttribute("type") ? e.getAttribute("type").toLowerCase() : "text" : t;
  }
  removeFields(e) {
    if (!Array.isArray(e)) {
      console.error("removeFields() must receive an array");
      return;
    }
    e.forEach((t) => {
      this.removeField(t);
    });
  }
  removeField(e) {
    if (typeof e != "string") {
      console.error("removeField() must receive a string");
      return;
    }
    const t = E(this, x).findIndex((s) => s.name === e);
    if (t !== -1) {
      const s = this.getField(e);
      this.resetFieldState(s), E(this, x).splice(t, 1);
    } else
      console.warn(`Cannot remove field named ${e} because it does not seem to exist`);
  }
  getField(e) {
    if (typeof e != "string") {
      console.error("getField() must receive a string");
      return;
    }
    return E(this, x).find((t) => t.name === e);
  }
  async submitHandler(e) {
    this.ajax && e && e.preventDefault(), !this.antiSpam && (F(this, B, !0), await this.validate(), this.isValid || e.preventDefault());
  }
  async validate() {
    this.resetFormState(), await this.validationSchema.validate(this.values, { abortEarly: !1 }).then((e) => {
      F(this, M, !0);
    }).catch((e) => {
      F(this, O, e.inner);
    }), this.isValid ? this.ajax && this.handleValidationSuccess() : this.handleValidationError();
  }
  resetFormState(e = !1) {
    F(this, M, !1), F(this, O, []), this.$el.classList.remove(this.classes.invalid, this.classes.valid, this.classes.serverError, this.classes.serverSuccess), E(this, x).forEach((t) => {
      e ? this.resetFieldValue(t) : this.resetFieldState(t);
    });
  }
  async handleValidationError() {
    await E(this, O).forEach((e) => {
      const t = this.getField(e.path);
      if (t === void 0) {
        console.warn(`Cannot find field named ${e.path}`);
        return;
      }
      this.setFieldState(t, e);
    }), this.$el.classList.add(this.classes.invalid), F(this, B, !1);
  }
  setFieldState(e, t) {
    if (e.$error) {
      e.$error.classList.remove("hide"), e.$error.setAttribute("aria-hidden", !1);
      const s = e.$error.querySelector(`[me\\:form\\:error="${t.type}"]`);
      s && (s.classList.remove("hide"), s.setAttribute("aria-hidden", !1));
    }
    e.$el.classList.add(this.classes.error);
  }
  resetFieldState(e) {
    e.$error && (e.$error.classList.add("hide"), e.$error.setAttribute("aria-hidden", !0), e.$error.querySelectorAll("[me\\:form\\:error]").forEach((t) => {
      t.classList.add("hide"), t.setAttribute("aria-hidden", !0);
    })), e.$el.classList.remove(this.classes.error);
  }
  resetFieldValue(e) {
    e.type === "checkbox" || e.type === "radio" ? e.$el.setAttribute("checked", !1) : e.type === "select" ? e.defaultValue && (e.$el.value = e.defaultValue) : e.$el.value = "", e.$el.trigger("change");
  }
  handleValidationSuccess() {
    this.$el.classList.add(this.classes.valid), this.recaptcha && typeof grecaptcha < "u" ? grecaptcha.execute(SETTINGS.RECAPTCHA_SITE_KEY, { action: this.recaptchaAction }).then((e) => {
      this.$recaptchaInput.value = e, this.handleAjaxSend(this.formatData(new FormData(this.$el)));
    }) : this.handleAjaxSend(this.formatData(new FormData(this.$el)));
  }
  formatData(e) {
    let t = new FormData();
    for (const s of e.entries()) {
      const r = s[0], i = s[1], a = this.$el.querySelector(`[name="${r}"]`), u = this.getField(r);
      if (!a.disabled && (i || this.acceptSendingEmptyValues)) {
        if (a.getAttribute("type") === "file" && i.size <= 0)
          continue;
        let o = i;
        typeof u < "u" && u.hasOwnProperty("format") && (o = u.format(o)), t.append(r, o);
      }
    }
    return t;
  }
  handleAjaxSend(e) {
    const t = this.method === "GET" ? `${this.action}?${new URLSearchParams(e)}` : this.action, s = {
      method: this.method,
      cache: "no-cache"
    };
    this.method === "POST" && (s.body = e), fetch(t, s).then((r) => {
      if (!r.ok || r.status < 200 || r.status > 300)
        throw new Error(r.statusText);
      return r;
    }).then((r) => r.headers.get("content-type").includes("application/json") ? r.json() : r).then((r) => {
      r && this.ajaxSuccess(r);
    }).catch((r) => r.response ? r.response.json() : { error: "Unknown error" }).then((r) => {
      r && this.ajaxError(r);
    }).finally(() => {
      this.ajaxComplete();
    });
  }
  ajaxSuccess(e) {
    this.reset(), this.$el.classList.add(this.classes.serverSuccess);
  }
  ajaxError(e) {
    this.$el.classList.add(this.classes.serverError);
  }
  ajaxComplete() {
    F(this, B, !1);
  }
  reset() {
    this.resetFormState(!0);
  }
  requirementsExist() {
    let e = !0;
    return this.method || (e = !1, console.error(`${this.name} needs to have a method`)), this.action || (e = !1, console.error(`${this.name} needs to have an action`)), E(this, x).length || (e = !1, console.error(`${this.name} needs a list of fields. To see what you need to add go check the README.md`)), this.$submit || (e = !1, console.error(`${this.name} needs to have a submit button`)), this.recaptcha && ((!window.SETTINGS || !SETTINGS.RECAPTCHA_SITE_KEY) && (e = !1, console.error("SETTINGS.RECAPTCHA_SITE_KEY needs to be defined")), this.recaptchaAction || (e = !1, console.error(`${this.name} needs to have a recaptcha-action attribute`)), this.$recaptchaInput || (e = !1, console.error(`${this.name} needs to have a input[name="${this.recaptchaInputName}"]`))), e;
  }
  fieldRequirementsExist(e) {
    let t = !0;
    return this.isPlainObject(e) || (t = !1, console.error("A field must be an object")), e.name ? this.$el.querySelector(`[name="${e.name}"]`) || (t = !1, console.error(`Couldn't find field with associated name :: ${e.name}`)) : (t = !1, console.error("A field must have a name parameter")), e.validationSchema || (t = !1, console.error("A field must have a validationSchema parameter")), t;
  }
  set acceptSendingEmptyValues(e) {
    if (typeof e != "boolean") {
      console.error('The "accept" parameter must be a boolean');
      return;
    }
    this._acceptSendingEmptyValues = e;
  }
  get acceptSendingEmptyValues() {
    return this._acceptSendingEmptyValues;
  }
  set action(e) {
    if (typeof e != "string") {
      console.error('The "action" parameter must be a string');
      return;
    }
    this._action = e;
  }
  get action() {
    return this._action;
  }
  set ajax(e) {
    if (typeof e != "boolean") {
      console.error('The "ajax" parameter must be a boolean');
      return;
    }
    this._ajax = e;
  }
  get ajax() {
    return this._ajax;
  }
  get antiSpam() {
    return E(this, B);
  }
  get errors() {
    return E(this, O);
  }
  get fields() {
    return E(this, x);
  }
  get isValid() {
    return E(this, M);
  }
  set method(e) {
    if (typeof e != "string") {
      console.error('The "method" parameter must be a string');
      return;
    }
    this._method = e.toUpperCase();
  }
  get method() {
    return this._method;
  }
  set name(e) {
    if (typeof e != "string") {
      console.error('The "name" parameter must be a string');
      return;
    }
    this._name = e;
  }
  get name() {
    return this._name;
  }
  set recaptcha(e) {
    if (typeof e != "boolean") {
      console.error('The "recaptcha" parameter must be a boolean');
      return;
    }
    this._recaptcha = e;
  }
  get recaptcha() {
    return this._recaptcha;
  }
  set recaptchaAction(e) {
    if (typeof e != "string") {
      console.error('The "recaptchaAction" parameter must be a string');
      return;
    }
    this._recaptchaAction = e;
  }
  get recaptchaAction() {
    return this._recaptchaAction;
  }
  set recaptchaInputName(e) {
    if (typeof e != "string") {
      console.error('The "recaptchaInputName" parameter must be a string');
      return;
    }
    this._recaptchaInputName = e;
  }
  get recaptchaInputName() {
    return this._recaptchaInputName;
  }
  get validationSchema() {
    const e = {};
    return E(this, x).forEach((t) => {
      e[t.name] = t.validationSchema;
    }), qe(e);
  }
  get values() {
    const e = new FormData(this.$el), t = {};
    return E(this, x).forEach((s) => {
      t[s.name] = e.get(s.name);
    }), t;
  }
  isPlainObject(e) {
    if (typeof e != "object" || e === null)
      return !1;
    const t = Object.getPrototypeOf(e);
    return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
  }
}
x = new WeakMap(), M = new WeakMap(), O = new WeakMap(), B = new WeakMap();
Me.forms.FormBase = Xt;
export {
  Xt as FormBase,
  Xe as FormManager
};
